/* eslint sort-keys: "error" */
export default {
    AccountDrawer: {
        accountActionsHeader: 'Account Actions',
        addNickname: 'Add a nickname',
        balance: 'Balance',
        deleteInstitutionSubtext: ' This will delete all accounts tied to this institution',
        deleteInstitutionTitle: 'Delete this institution',
        editLogin: 'Edit login details',
        emptyStateBody: 'This account’s transactions are being hidden from PlanAhead',
        emptyStateSubtextLink: 'Show this account',
        emptyStateSubtextNonLink: 'to see an updated transactions list',
        enterNickname: 'Enter nickname',
        hiddenAlertMessage: 'This account is currently hidden from PlanAhead',
        hideAccountTitle: 'Hide this account',
        institution: 'Institution Name',
        issueMessage: 'There is a problem with your account',
        latestTransactionsHeader: 'Latest Transactions',
        name: 'Account Name',
        nickname: 'Account nickname',
        pageTitle: 'Account Details',
        rewardsCheckingSubtext: 'URLs TBD. View the summary screen for this account',
        rewardsCheckingTitle: 'Go to [Rewards Checking Account]',
        showAccountTitle: 'Show this account',
        viewTransactions: 'View all transactions for this account'
    },
    AccountSyncBanner: {
        linkingInProgress: 'Linking in Progress.',
        pleaseReview: ' Please review your accounts below.',
        tryLinkingAgain: 'Try Linking Again',
        unableToCompleteLinking: 'Unable to complete linking.',
        yourSpendSmartInformation: 'Your SpendSmart™ information might not be up-to-date. ',
        yourSpendingInformation:
            'Your spending information may take a few minutes to update as your account syncs. SpendSmart™ will' +
            ' refresh after your account is fully linked.'
    },
    AddAccounts: {
        mobileConnect:
            '<b>Mobile account syncing is currently in BETA</b>. Some accounts may not connect correctly or cause an error.'
    },
    AdjustExpensesDrawer: {
        intro: 'Looking to model a change to your expenses? Increase or decrease your monthly expense projections for a set period. Your expense projections will be based on your current spending data outside of this period.'
    },
    Admin: {
        Account: {
            DeleteInstitution: {
                accountHeader: 'Accounts',
                deleteHeader: 'Actions',
                institutionHeader: 'Institution',
                loading: 'Loading Institutions...'
            },
            SyncStatus: {
                accountHeader: 'Account',
                currentStatusHeader: 'Current Status',
                loading: 'Loading Accounts...',
                newStatusHeader: 'New Status',
                saveButton: 'Save Account Errors',
                title: 'Set Account Sync Errors',
                unchanged: 'Unchanged'
            }
        },
        Email: {
            alertEmailButton: 'Budget Alert Email',
            cronTitle: 'Schedule PlanUpdate Cron',
            monthlyEmailButton: 'Budget Monthly Email',
            scheduleCronEmailButton: 'PlanUpdate Monthly Email',
            title: 'Send Emails',
            welcomeEmailButton: 'Budget Welcome Email'
        },
        User: {
            budgetPlanLabel: 'SpendSmart',
            cornerstoneTitle: 'Cornerstone',
            emailLabel: 'Email Address',
            forceHideUnhideAccounts: 'Force hide unhide accounts',
            fullPlanLabel: 'Full MFP',
            makeMeExistingUser: 'Make me an existing user',
            makeMeNativeAppUser: 'Make me a native app user',
            makeMeNewUser: 'Make me a new user',
            makeMeWebAppUser: 'Make me a web app user',
            markDoneTransactionClassificationWalkme: 'Mark Done Txn Class Walkme',
            neverShowCreateRulePrompt: 'Never show create rule prompt',
            planTypeTitle: 'Plan Types',
            resetTransactionClassificationWalkme: 'Reset Txn Class Walkme',
            runCornerstoneButton: 'Run Cornerstone Job Async',
            showCreateRulePrompt: 'Show create rule prompt',
            snapshotLabel: 'Snapshot Dataset',
            termsDescription:
                'Sets the terms of service version that the user has accepted. This can be empty to indicate that the user has not accepted a terms of service.',
            termsLabel: 'Terms Version',
            unchangedSnapshot: 'Unchanged',
            updateButton: 'Update User Data',
            userAttributes: 'User Attributes',
            warning: 'Warning:',
            warningMessage: ` This will delete all data for the current user and replace it with the "$\{args[0]}" snapshot!`
        },
        accountTabTitle: 'Account',
        emailTabTitle: 'Email',
        title: 'PLAN/SpendSmart Admin Page',
        userTabTitle: 'User'
    },
    AgeDrawer: {
        invalid: 'Enter date as Month, Day, Year (MM/DD/YYYY)',
        tooOld: `$APP_NAME is for those under 100 years old`,
        tooYoung: 'We applaud your desire to start planning early but you need to be at least 13 to use $APP_NAME'
    },
    AssetDebtDrawer: {
        assetMetricTitle: `$\{args[0] ? 'Projected' : ''} Asset`,
        assetsTooltip: `Your $\{args[0] ? 'projected' : ''} assets$\{args[0] ? ' after life events.' : ''}`,
        baselineSavings: 'Baseline Savings',
        debtInfo: 'Debt balances are the remaining balance after estimated minimum payments.',
        debtMetricTitle: `$\{args[0] ? 'Projected' : ''} Debt`,
        debtSectionTooltip: 'Liabilities such as loans, mortgages, and credit card balances.',
        debtTitle: `$\{args[0] ? 'Projected' : ''} Debt`,
        debtTooltip: `Your $\{args[0] ? 'projected' : ''} debt$\{args[0] ? ' after life events.' : ''}`,
        joinDiscussion: 'Join the discussion',
        liquidAssetsTitle: `$\{args[0] ? 'Projected' : ''} Liquid Assets`,
        liquidAssetsTooltip: 'Assets like cash & savings that are readily available for spending.',
        netWorthMetricTitle: `$\{args[0] ? 'Projected' : ''} Net worth`,
        netWorthTooltip: `Your $\{args[0] ? 'projected' : ''} net worth$\{args[0] ? ' after life events.' : ''}`,
        projection:
            '$APP_NAME uses several different types of modeling to evaluate and project your plan based on your current accounts, balances, and asset types.',
        restrictedAssetsInfo: 'Asset balances shown are the base asset value plus compounded growth over time.',
        restrictedAssetsTitle: `$\{args[0] ? 'Projected' : ''} Restricted Assets`,
        restrictedAssetsTooltip: "Assets that can't easily be converted to cash.",
        title: `Your Asset & Debt Report for $\{args[0]}`,
        tooltipTitle: 'Projections'
    },
    Budget: {
        Chart: {
            categoryBarChartTitle: 'Category History Chart',
            generalBarChartTitle: 'General History Chart',
            spendingLineChartTitle: 'Spending Chart',
            viewTransactionsFor: `Bar graph label and link to view all of your $\{args[0]} transactions for $\{args[1]}`
        },
        Connect: {
            agreeAndLinkAccount: 'Agree & Link Account',
            callout: {
                accounts: 'accounts',
                addNonAmericanExpressAccounts: 'Add non-American Express Accounts',
                connectYourNonAmericanExpressAccounts:
                    'Connect your non-American Express accounts for the most accurate view into your overall spending. For example:',
                creditCards: 'Credit cards',
                debitCards: 'Debit cards',
                forMoreInformation:
                    ' for more information about how we integrate with Plaid, a financial services company, to link your financial institutions.',
                ifYouDontWant: 'If you don’t want to link an account just yet, you can do so later in your Settings.',
                linkYourOtherFinancial: 'Link your external financial ',
                linkYourOtherFinancialAccounts: 'Link your external financial accounts',
                privacyLink: 'American Express Privacy Center',
                privacySecondaryText:
                    '. Note that American Express will only share with American Express affiliates or' +
                    ' otherwise at your direction.',
                privacyText:
                    ' AND consent to American Express accessing, collecting, using, and sharing your' +
                    ' external financial account information as described in those terms and at the ',
                securelyLinkYourAccounts: 'Get a better view into your spending habits by linking your accounts.',
                spendingAccountsFromBanks: 'Spending accounts from banks and other financial institutions',
                termsAndConditionsText:
                    'By selecting “Agree & Link Account” you confirm you have reviewed and agree to the ',
                whenYourAccountsAreLinked: 'When your accounts are linked:',
                youCanSeeYour:
                    'You can see your transactions from American Express and linked accounts in one place, automatically.',
                youCanTrack: 'You can track the information that’s most important to you.',
                yourAccountsAreConnected:
                    'Your accounts are connected securely and privately. If you don’t want to connect more accounts just yet, you can add them later in your Settings.',
                yourDataIsEncrypted: 'Your data is encrypted.'
            },
            cardTitle: 'SpendSmart™ Accounts & Income',
            form: {
                hint: 'Share your income to help ensure your SpendSmart™ information is accurate. ',
                label: 'Your annual pre-tax income'
            },
            income: 'Income',
            nextButton: 'Next',
            nonTaxableInputError:
                'Please enter an amount greater than 0, or uncheck the box above if you have no nontaxable income.',
            nontaxableCheckboxLabel: 'Part of my income is nontaxable',
            nontaxableIncomeTooltip:
                'Non-taxable income is exempt from federal income tax. Income of this type includes Social Security payments, child support, public assistance, disability, workers compensation, and military allowances. If you’re under 21, please include your personal income only.',
            nontaxableIncomeTooltipLabel: 'nontaxable income tooltip',
            nontaxableInputLabel: 'Amount of income that is nontaxable',
            onboardingStep: 'Step 1 of 2:',
            pendingCharges: {
                content:
                    'You can toggle off an account, which will hide that account from SpendSmart™. Hiding an account' +
                    ' means that that account’s information will no longer be considered in SpendSmart™, but the' +
                    ' account will not be deleted. When you hide an account, any transaction customizations you\u0027ve' +
                    ' made will not be saved. You can unhide an account at any time by toggling it back on, but it' +
                    ' may take a few minutes to start syncing your account again. Please note that once you hide' +
                    ' an account we may continue to process your information in accordance with the ',
                title: '*How do I hide or unhide an account from SpendSmart™?'
            },
            plusNOtherNoncash: `Plus $\{args[0]} other non Cash and Expense accounts not used for budgeting`,
            selectAccountsToInclude: 'Accounts toggled on are included in SpendSmart™*',
            spendingAccounts: 'Spending Accounts',
            subtitle:
                'Select the accounts you’d like to use in SpendSmart™. Link your non-American Express accounts for a complete view into your overall spending.',
            taxableIncomeTooltip:
                'Include any income that’s available to you to make payments on this account. For example, income might come from wages, retirement, investments, rental properties, or from another person whose income you have regular access to. If you’re under 21, you must include only your personal income. Alimony, child support, or separate maintenance need not be revealed if you do not wish to rely on it.',
            taxableIncomeTooltipLabel: 'pre-tax income tooltip',
            title: 'Set Accounts & Income',
            tooltip: {
                consumerCheckingAccounts: 'Consumer checking accounts',
                consumerCreditCards: 'Consumer credit cards',
                externalFinancialAccountsInclude: 'External financial accounts include',
                readMoreAboutConnectingAccounts: 'Read more about linking accounts'
            },
            wellUseYour:
                'We’ll use your American Express spending accounts to track your progress each month, along with any non-American Express spending accounts you link.',
            wrongNumberQuestion: 'Does this number look wrong?',
            wrongNumberText:
                'Large one-time purchases can skew your average monthly spending. After you’ve set up SpendSmart™, you can view a transaction’s details and update the frequency of that transaction to “one-time” or “ignore” to exclude it from your averages to better reflect your typical spending habits.',
            yourAverageMonthlySpending: 'Your average monthly spending'
        },
        Create: {
            addCategory: 'Add Category',
            addSpecificSubcategory: `Add $\{args[0]} subcategory`,
            addSubcategory: 'Add Subcategory',
            amountAvailable: 'Available for additional subcategories:',
            amountLabel: 'Amount',
            cardTitle: 'Select Categories',
            categoryLabel: 'Category',
            categoryOverSpendingWarningBanner: {
                close: 'Close warning',
                description:
                    'Your budget categories are exceeding your target monthly spending. Consider changing your budget amounts if you’d like to stay under your target.'
            },
            categoryTotalWarning: 'This is less than the categories total.',
            monthlyAverage: 'Your monthly average',
            monthlyAverageAllAccounts: 'Across all accounts',
            monthlyAveragePercent: `$\{args[0]}% of overall spending`,
            monthlyAverageTitle: 'Monthly average',
            monthlyAverageTooltip:
                'Based on the last 12 full months from the accounts you’ve included in SpendSmart™.',
            new: 'New',
            newBudget: 'New budget',
            nextButton: 'Confirm',
            noCategories: "You don't have any categories",
            personalizeCategoryHeader: {
                targetMonthlySpending: 'Target monthly spending',
                totalBudgetForCategories: 'Total budget for categories'
            },
            removeCategory: 'Remove Category',
            removeSpecificCategory: `Remove $\{args[0]} $\{args[1]}`,
            removeSubcategory: 'Remove Subcategory',
            sourceLabel: 'Source',
            subcategoryError: 'Subcategory is required',
            subcategoryLabel: 'Subcategory',
            subcategoryTotalError: 'This is higher than the category total',
            subtitle:
                'Set a budget for specific categories and subcategories in SpendSmart™. You can track as many, or as few, as you’d like.',
            title: 'Budget Categories',
            viewCategoryHistory: 'View category history'
        },
        Current: {
            accountNumberLinkDescription: `$\{args[0]} accounts. View Account Settings.`,
            budgetStatsBox: {
                budgetForTrackedCategoriesTitle: 'Budget for tracked categories',
                budgetForTrackedCategoriesTooltip: 'The total budget for all tracked categories.',
                leftOverBudgetCategoriesTitle: 'Left over',
                leftOverBudgetCategoriesTooltip:
                    'The difference between your budget and total spent in your tracked' + ' categories.',
                title: 'Budget categories',
                totalSpentBudgetCategoriesTitle: 'Total spent in these categories',
                totalSpentBudgetCategoriesTooltip:
                    'The total amount you have spent in your tracked categories so far this month.'
            },
            categorySpending: 'Category-based spending:',
            chartNoData: 'You have no spending yet this month.',
            currentSpendingThisMonth: 'Total spent this month',
            edit: 'Edit',
            exceeding: 'Exceeding',
            graph: {
                comparisonMonth: 'Comparison Month',
                currentMonth: 'Current month',
                dropdownLabel: 'Compare to',
                lastMonth: 'Last month',
                thisMonthLastYear: 'This month last year'
            },
            moAmount: 'Mo. amount: ',
            monthlyAmount: 'Monthly amount: ',
            otherSpending: 'All other spending:',
            progressBarAriaLabel: `bar chart showing spend of $$\{args[0]}, $\{args[1]} of total budget`,
            remaining: 'Remaining',
            spent: 'Spent:',
            targetMonthlySpendingStatsBox: {
                editIconTitle: 'Edit target monthly spending',
                leftOverTitle: 'Left over',
                leftOverTooltip: 'The difference between your target monthly spending and total spent.',
                targetMonthlySpendingTitle: 'Target monthly spending',
                targetMonthlySpendingTooltip: 'The target amount you would like to spend this month.',
                totalSpentTitle: 'Total spent',
                totalSpentTooltip: 'The total amount you have spent so far this month.'
            },
            targetSpendingTitle: 'Target monthly spending',
            targetSpendingTooltip: 'The target amount you would like to spend this month.',
            totalMonthlySpending: 'Total Monthly Spending',
            totalSpentTitle: 'Total spent',
            totalSpentTooltip: 'The total amount you have spent so far this month.',
            trackYourTotal: 'Track your total monthly spending across all available accounts.',
            viewAllTransactionsLinkDescription: `View transactions for this month`,
            viewHistory: 'View History',
            viewHistoryFor: `View History for $\{args[0]}`,
            viewTransactions: 'View Transactions',
            viewTransactionsFor: `View Transactions for $\{args[0]}`,
            viewTransactionsForLastX: `View transactions for the last $\{args[0]} full months`,
            viewTransactionsLinkDescription: `View $\{args[0]} transactions for this month`,
            viewTransactionsModalLinkDescription: `Link to view all of your $\{args[0]} transactions for the last 12 full months`
        },
        EmailPreferences: {
            aSummaryOfYour: 'A summary of your SpendSmart™ activity over the last month.',
            anOverviewOfWhere: `An overview of where you're overspending, or close to overspending, based on your target monthly amount and/or budget categories. Depending on your spending, you may receive multiple updates throughout the month, but no more than once per day.`,
            emailNotifications: 'Email Notifications',
            error: "We're having trouble loading this section.",
            fromYourAccountEndingIn: ' from your account ending in ',
            monthlySummaryEmail: 'Monthly Summary Email',
            selectTheEmails: 'Select the emails you would like to receive.',
            spendSmartUpdateEmail: 'SpendSmart™ Update Email',
            tryAgain: 'Try again',
            unableToDisplayEmail: 'Unable to display email address and account number.',
            visitYourAccountServices: 'Visit your Account Services Profile to update your email address',
            weWillContact: 'We will contact you using your email address ',
            weWillContactError:
                'We will contact you using the email address where you receive messages from American Express.'
        },
        History: {
            averageMonthlySpending: 'Average monthly spending',
            categoryModalHeader: `$\{args[0]} History`,
            categoryModalOutputTitle: 'Average Monthly Spending',
            chartNoData: 'You have no spending yet this year.',
            chartTitle: 'History',
            collapsibleSection: {
                body: 'Your average monthly spending is calculated based on the typical spending in your accounts for up to the last 12 full months.',
                title: 'How is this calculated?'
            },
            viewTransactionsLinkDescription: `Link to an overview of your $\{args[0]} spending history for the last 12 full months`
        },
        HistoryTable: {
            amount: 'Amount',
            currentMonth: 'Current month',
            differenceOver: 'Over',
            differenceUnder: 'Under',
            transactionsList: 'Transactions List'
        },
        Settings: {
            accountNameAriaLabel: `List item label for $\{args[0]} ending in $\{args[1]}`,
            accountNameAriaLabel2: `List item label for $\{args[0]}`,
            institutionsAreDisconnected: ' institutions are disconnected. ',
            isDisconnected: ' is disconnected. ',
            moreInfo: 'For more information see our ',
            reconnectNow: 'Reconnect Now',
            termsAndConditions: 'Terms & Conditions',
            title: 'Settings',
            toggleNameAriaLabelNoAccount: `$\{args[0]} switch button}`,
            toggleNameNameAriaLabel: `$\{args[0]} ending in $\{args[1]} switch button`
        },
        andThe: ', and the ',
        backButton: 'Back',
        createCategoryBudget: 'Create Category Budget',
        current: 'Current',
        currentMonth: 'Current Month',
        dataConnectionTermsAndConditionsLink: 'SpendSmart™ Data Connection Terms & Conditions',
        editCategoryBudget: 'Edit Category Budget',
        lastMonth: 'Last Month',
        learnMoreText: 'Learn more about Budgets',
        learnMoreUrl: 'https://www.bodeswell.io/articles/budgets-in-bodeswell',
        privacyCenter: 'Privacy Center',
        termsAndConditions: 'Terms & Conditions',
        theAmex: ', the Amex ',
        title: 'SpendSmart™',
        titles: {
            app: 'SpendSmart™',
            error: 'Error',
            history: 'History',
            home: 'Home',
            ineligible: 'Eligibility',
            personalize: 'Budget Categories',
            reviewTransactions: 'Review Transactions',
            setAccountsAndIncome: 'Set Accounts & Income',
            settings: 'Settings',
            transactionDetails: 'Transaction Details',
            transactionRules: 'Transaction Rules',
            transactions: 'Transactions'
        },
        unenroll: {
            alert: {
                areYouSure: 'Are you sure you want to unenroll from SpendSmart™? This cannot be undone.',
                cancel: 'Cancel',
                unenrollFromSpendSmart: 'Unenroll from SpendSmart™?'
            },
            thisCannotBeUndone: 'This cannot be undone.',
            unenroll: 'Unenroll',
            unenrollFromSpendSmart: 'Unenroll from SpendSmart™',
            whenYouUnenroll:
                'When you unenroll, you will no longer be able to access your tracker, categories, and all related history. Unenrolling disconnects your accounts from SpendSmart™ as well. Please note that once you unenroll we may continue to process your information in accordance with the '
        }
    },
    BudgetAmount: {
        title: 'Budget: '
    },
    BudgetEditButton: {
        create: 'Create Budget',
        edit: 'Edit Budget'
    },
    BudgetNoAccounts: {
        button: 'Connect primary account',
        subtitle1: 'Connect the account you pay most of your bills from',
        subtitle2:
            'Budgets needs at least one connected account to work. For best results, connect the account you pay most of your bills from.',
        title: 'Set a budget'
    },
    BudgetNotConnected: {
        button: 'Signup for $APP_NAME',
        subtitle1: 'You need to have a $APP_NAME account to create a budget',
        subtitle2: 'Without a $APP_NAME account you can’t connect accounts or track spending.',
        title: 'Sign up for $APP_NAME'
    },
    BudgetStatsBox: {
        budgetForTrackedCategoriesTitle: 'Budget for tracked categories',
        budgetForTrackedCategoriesTooltip: 'The total budget for all tracked categories.',
        leftOverBudgetCategoriesTitle: 'Left over',
        leftOverBudgetCategoriesTooltip:
            'The difference between your budget and total spent in your tracked' + ' categories.',
        title: 'Budget categories',
        totalSpentBudgetCategoriesTitle: 'Total spent in these categories',
        totalSpentBudgetCategoriesTooltip:
            'The total amount you have spent in your tracked categories so far this month.'
    },
    BuyHome: {
        additionalOptions: 'Additional options',
        downPayment: `This is $\{args[0]}% of the home’s price.`,
        insurance:
            'If you pay less than 20% it could require you to pay Private Mortgage Insurance which can increase your costs.',
        intro: 'Add a scenario that shows how the cost of a home will affect your plan or understand how much you can afford with an optional savings goal.',
        learnMore: 'Learn about how we calculate a home purchase.',
        sellExisting: 'Sell an existing property'
    },
    Callout: {
        HighYieldSavings: {
            description:
                'Did you know you can earn 10X more interest than your average savings with a High Yield Savings Account?',
            header: 'American Express High Yield Savings',
            learnMore: 'Learn more'
        }
    },
    CategoryHistoryModal: {
        viewSpendingHistory: 'View your spending history for that category'
    },
    CharityDrawer: {
        body: 'Want to give more to charity without endangering your or your family’s financial security? Use this scenario to see what you can safely donate each year.',
        tax: 'This estimate does not include any tax implications of this event.'
    },
    CollectSocialSecurityDrawer: {
        help: 'Learn more about social security payments.',
        info: 'Estimating how much you will get from Social Security is complicated. It’s based on a number of factors like how long you worked, how much you made each year, inflation, and what age you start collecting your benefits.<br/><br/>We use these variables and the Social Security and Supplemental Security Income (SSI) benefits formula, as announced in October 2020, to estimate your expected payment. We don’t currently factor in spousal survivor benefits into our Social Security estimate.',
        monthly: 'Social Security monthly benefits',
        percent: `You’ll collect $\{args[0]}% of your Social Security benefits`,
        startDate: 'When do you want to start collecting?'
    },
    CommonLabels: {
        name: 'Name or nickname'
    },
    CommonText: {
        add: 'Add',
        apply: 'Apply',
        back: 'Back',
        cancel: 'Cancel',
        confirm: 'Confirm',
        delete: 'Delete',
        edit: 'Edit',
        remove: 'Remove',
        save: 'Save',
        update: 'Update',
        yes: 'Yes'
    },
    ConnectAssetAccounts: {
        buttonText: 'Connect account',
        content1:
            'Connect your bank, investment, or asset accounts for automatically updating balances, pricing, and values.',
        content2: 'This is the best way to experience $APP_NAME.',
        header: 'Connect Your Bank, Investments, or Asset Accounts'
    },
    CreateDateScenarioDialog: {
        everything: 'Everything prior to this date will be copied to your new scenario.',
        when: 'When do you want to branch your current scenario?'
    },
    CreateRuleBox: {
        applyButton: 'Apply',
        applyLabel: 'Apply rule',
        close: 'Close create rule box',
        createRule: 'Create Rule',
        title: 'Create a transaction rule',
        transactionRuleDescription:
            'Set expense categories and income sources for all similar transactions in the future.'
    },
    CreateScenarioDialog: {
        create: 'Create new scenario'
    },
    CreateTransactionRulePrompt: {
        button: 'Create Rule',
        description: 'Set expense categories and income sources for all similar transactions in the future.'
    },
    CryptoDrawer: {
        buttonLabelAdd: 'Add crypto',
        buttonLabelUpdate: 'Update crypto',
        currencyNameField: {
            errorLabel: 'Currency',
            label: 'Currency name',
            placeholder: 'Crypto currency name'
        },
        currencyQuantityField: {
            errorLabel: 'Quantity',
            label: 'Coin quantity'
        },
        headings: {
            add: 'Add crypto currency',
            update: 'Crypto details'
        },
        isRequired: 'is required',
        titles: {
            add: 'Add crypto',
            update: 'Crypto details'
        },
        totalSection: {
            heading: 'Total',
            priceUpdate: `$\{args[0]} per coin. Last updated $\{args[1]}`
        }
    },
    CustomSubcategoryModal: {
        alreadyExists: 'Subcategory name already exists. Try using another name.',
        customSubcategoryOption: 'Add custom subcategory',
        error: 'The date you have entered is not valid',
        header: 'Add Custom Subcategory',
        name: 'Subcategory Name',
        required: 'Custom subcategory name is required'
    },
    DateGoalDrawer: {
        '2008': {
            intro: 'This event models what would happen to your portfolio if the 2008 financial crash were to repeat itself. It simulates the largest peak to trough drop from 2008 based on historical correlations with the asset classes in your portfolio.  From that trough, we project returns based on a <a target="_blank" rel="noopener noreferrer" href="https://support.whale-app.bodeswell.io/articles/monte-carlo">50th percentile Monte Carlo projection</a>.'
        },
        '2010': {
            intro: 'This event models the impact of the 2010 financial boom on your portfolio. It simulates your portfolio going through what happened to portfolios during the market recovery starting in March 2009 and continuing over the next two years. From there, we use a 50th percentile Monte Carlo projection.'
        },
        eol: {
            intro: 'Planning for the unexpected isn’t easy. This moment will show how your passing will affect loved ones, so you can plan for how to protect them now.<br/><br/>On the date of this event, we will end all income and expenses, add a final $10,000 funeral expense, pay off all debts with assets and donate 1% of retirement income to charity. Estate taxes and other estate planning considerations are not included in this projection.',
            learnMore: 'Learn more about End of life'
        },
        learnMore: 'Learn more about projections',
        oil: {
            intro: 'This simulates global events that hit the largest oil producing countries and rippled through the U.S. economy in 1973. We model the effect of those historical events on your portfolio before reverting to a 50th percentile Monte Carlo projection.'
        },
        startDateLabel: 'Date'
    },
    DateRange: {
        DateLabels: {
            accessibleHint: 'Please enter month, day, and year, separated by a /',
            calendarButton: 'Toggle Calendar',
            end: 'End Date',
            nextMonth: 'Next month',
            previousMonth: 'Previous month',
            start: 'Start Date'
        },
        Modal: {
            endDateRequired: 'End date is required',
            header: 'Date',
            label: 'Select a date range',
            startDateRequired: 'Start date is required'
        },
        endDate: 'End Date',
        startDate: 'Start Date'
    },
    DebtDrawer: {
        ConnectAssetAccounts: {
            content1: 'Connect your debt or loan accounts for automatically updating balances and values.',
            header: 'Connect a Debt Account'
        },
        amountInputError: 'Total is required',
        amountMustBeGreaterThanZeroError: 'Total must be greater than 0',
        auto: {
            amountLabel: 'Original auto loan amount',
            amountSublabel: 'The initial amount of your loan',
            durationLabel: 'Loan duration',
            optionText: 'Auto Loan'
        },
        creditCard: {
            amountLabel: 'Current credit card balance',
            optionText: 'Credit Card'
        },
        debtDurationError: 'Duration is required',
        debtNameLabel: 'Debt name',
        debtTypeError: 'Type is required',
        debtTypeLabel: 'Type of debt or loan',
        endDateLabel: 'Debt end date (optional)',
        interestError: 'Rate is required',
        interestLabel: 'Interest rate',
        months: 'months',
        mortgage: {
            amountLabel: 'Original mortgage amount',
            amountSublabel: 'The initial amount of your loan',
            durationLabel: 'Original mortgage terms',
            optionText: 'Mortgage'
        },
        nameInputError: 'Name is required',
        other: {
            amountLabel: 'Current balance',
            endDateLabel: 'Debt end date (optional)',
            optionText: 'Other'
        },
        personal: {
            amountLabel: 'Current personal loan balance',
            amountSublabel: 'Your balance as of today',
            durationLabel: 'Loan duration',
            optionText: 'Personal Loan'
        },
        startDateLabel: 'Debt start date',
        student: {
            amountLabel: 'Original student loan amount',
            amountSublabel: 'The initial amount of your loan',
            durationLabel: 'Loan duration',
            optionText: 'Student Loan'
        },
        title: 'Add a Debt or Loan',
        year: 'year'
    },
    DeleteScenarioDialog: {
        body: `Are you sure you want to delete the $\{args[0]} scenario? This cannot be undone.`
    },
    Disclosures: {
        allRightsReserved: '© 2022 American Express. All rights reserved.',
        allUsers: [
            'All users of our online services are subject to our',
            'and agree to be bound by the',
            '. Please review.'
        ],
        anchorText: {
            privacyStatement: 'Privacy Statement',
            securityCenter: 'Security Center',
            termsOfService: 'Terms of Service'
        },
        investing:
            'All investing involves risk, including the possible loss of money you invest, and past performance does not guarantee future performance. Historical returns, expected returns, and probability projections are provided for informational and illustrative purposes, and may not reflect actual future performance. Nothing in this communication should be construed as an offer, recommendation, or solicitation to buy or sell any security.',
        projections: `Projections are provided for informational and illustrative purposes only. The projections and other information presented in $\{args[0]} regarding the likelihood of future events are hypothetical, do not reflect actual investment results or the performance of actual accounts, and are not a guarantee of future results. Results may vary with each use and over time. Nothing in this communication should be construed as an offer, recommendation, or solicitation to buy or sell any security.`
    },
    DragAndDropRules: {
        emptyState: {
            noRules: "You don't have any rules yet",
            viewDetails: 'View a transaction’s details to create a rule.'
        }
    },
    DragRule: {
        drag: 'Drag rule'
    },
    DrawButton: {
        learnMore: 'Learn more about how we do this',
        learnMoreUrl: 'https://google.com',
        subtitle:
            '$APP_NAME will draw down the balances of the selected accounts in priority order from top to bottom.',
        title: 'Select & prioritze accounts to draw down'
    },
    Drawer: {
        privacySecurity: 'You are in control, learn more about our privacy and security practices by clicking here.'
    },
    EmergencyFundDrawer: {
        connected: 'You have no connected accounts to save to.',
        enable: 'Connect an account to enable savings goals.',
        intro: '3 months worth of expenses is a good benchmark for emergency savings.',
        suggest: 'Based on your current expenses, we recommend your emergency fund total:'
    },
    Error: {
        americanExpressHomepage: 'American Express homepage.',
        anErrorOccurred: 'An Error Occurred',
        youCanGoBack: 'You can go back and try again, re-enter the URL, or visit the '
    },
    ExpandableText: {
        hideDetails: 'Collapse section to hide details',
        showDetails: 'Expand section to learn more'
    },
    ExpenseDrawer: {
        callout: 'Do not include your American Express spending.',
        inputHint: 'The average amount you spend every month',
        inputLabel: 'Average additional monthly expenses',
        optionsBox: {
            button: 'Connect Account',
            content1:
                'Connect your spending accounts for real-time spending, automatically categorized transactions, and the ability to create budgets.',
            content2: 'This is the best way to experience PlanAhead.',
            header: 'Connect An Expense Account'
        },
        title: 'Update Expenses',
        updateButton: 'Update Expenses'
    },
    ExpenseGoalDrawer: {
        baby: {
            startDateLabel: 'Child’s date of birth',
            subtitle: 'Fantastic news. We are here to help... except with changing diapers.',
            tip1: 'Did you know? The ',
            tip2: ' estimates the cost of raising a child from birth through age 17 is $233,610!'
        }
    },
    ExpensesDrawer: {
        additionalExpenses: 'Additional Expenses',
        expensesByCategory: 'Expenses by category',
        familyTitle: "Your Family's Expenses",
        last12: 'Last 12 Months Expenses',
        learnMore: 'Learn more about projections',
        title: 'Your Expenses',
        topExpenses: 'Your top expenses',
        totalSpending: 'Total spending',
        transactionHistory:
            '$APP_NAME uses the last 12 full months of transaction history to create your expenses projections.'
    },
    FinancialProfile: {
        AccountsBody:
            'The accounts that PlanAhead uses to create your income, expenses, net worth, and all projections.',
        AccountsHeading: 'PlanAhead Accounts',
        ActionBoxCta: 'Your data stays yours. Read our data policy.',
        ActionBoxHeading: 'Connecting your external accounts is the best way to experience PlanAhead.',
        AddAccountButtonText: 'Add account',
        AddFamilyLinkText: 'Add family member',
        Assets: 'Assets',
        CreditCards: 'Credit cards',
        Crypto: 'Crypto',
        Debt: 'Debt',
        Deposits: 'Depository',
        ExpenseActionText: 'View my expenses',
        ExpenseBottomText: 'Last 12 months',
        ExpenseTopTextFamily: "My Family's Expenses",
        ExpenseTopTextSingle: 'My Expenses',
        HeaderInfoCardSubtitle: 'Learn more about our privacy and security practices',
        HeaderInfoCardTitle: 'You are in control of your data',
        HelpIconTitle: 'Help',
        HiddenAccounts: 'Hidden Accounts',
        HiddenAccountsTooltipText: 'These accounts, their transactions, and balances are hidden from PlanAhead.',
        IncomeActionText: 'View my incomes',
        IncomeBottomText: 'Last 12 months',
        IncomeTopTextFamily: "My Family's Income",
        IncomeTopTextSingle: 'My Income',
        NetWorthActionText: 'Connect Accounts',
        NetWorthBottomText: 'Across all accounts',
        NetWorthTopTextFamily: "My Family's Net Worth",
        NetWorthTopTextSingle: 'My Net Worth',
        OverviewBody:
            'A snapshot of your finances as PlanAhead sees them today. Your income and expense values power your projections.',
        OverviewHeading: 'Overview',
        OverviewLinkText: 'Read about how we calculate projections',
        PageTitle: 'Financial Profile',
        PeopleHeadingFamily: 'My Family',
        PeopleHeadingSingle: 'My Info',
        RealEstate: 'Property',
        TooltipText: 'Values derived from your accounts',
        disconnectedInstitution: `$\{args[0]} is disconnected.`,
        disconnectedInstitutions: `$\{args[0]} institutions are disconnected. Reconnect below.`,
        hiddenAccountInfo: 'These accounts, their transactions, and balances are hidden from your plan.'
    },
    FormErrors: {
        amountGreaterThanZero: 'Amount must be greater than 0',
        amountLessThanMillion: 'Target monthly spending cannot exceed $1,000,000.00. Please enter a lower amount.',
        amountRequired: 'Amount is required',
        birthDatePast: 'Birth date must be in the past',
        birthDateRequired: 'Birth date is required',
        categoryRequired: 'Category is required',
        endDateAfterStartDate: 'End date must be after start date',
        endDateMax: 'End date cannot be after End of Life',
        endDateRequired: 'End date is required',
        frequencyRequired: 'Frequency is required',
        incomeIsRequired: 'Income is required',
        nameInputError: 'Name is required',
        pleaseProvideANumber: 'Please provide a number',
        relationshipRequired: 'Relationship is required',
        required: 'Required',
        startDateFuture: 'Start date cannot be in the past',
        startDateMax: 'Start date cannot be after End of Life',
        startDateMin: 'Start date cannot be before birth',
        startDatePast: 'Start date must be in the past',
        startDateRequired: 'Start date is required'
    },
    General: {
        dropdown: {
            nestedHeading: `This is the start of the $\{args[0]} section. $\{args[0]}`,
            nestedOption: `$\{args[0]} within $\{args[1]}`
        },
        graph: {
            noData: 'No data.'
        },
        grid: {
            noDataSubtext: 'Your total spending in various categories will be displayed here from highest to lowest.',
            noDataText: 'You don’t have any spending by category.'
        },
        progressCircle: 'Progress Circle',
        search: {
            ariaLabel: 'Search available options',
            noResults: 'No Results',
            noResultsFor: `No results for "$\{args[0]}"`,
            placeholder: 'Search'
        }
    },
    GoalWarnings: {
        afterIncomeEnds: 'The associated income ended before this event',
        beforeIncomeStarts: 'The associated income starts after this event',
        requiresIncome: 'You have no income associated with this event'
    },
    Goals: {
        '2008 crash': '2008 Financial Crisis',
        '2010 boom': '2010 Financial Boom',
        'adjust expenses': 'Adjust Expenses',
        'budget expenses': 'Budget Expenses',
        'buy new home': 'Buy New Home',
        'care for a family member': 'Care for a Family Member',
        'child starts college': 'Child Starts College',
        'collect social security': 'Collect Social Security',
        'donate a portion of your income': 'Donate a Portion of Your Income',
        'end of life': 'End of life',
        'estimate life insurance': 'Estimate Life Insurance',
        'get promoted': 'Get Promoted',
        'have a baby': 'Grow Your Family',
        'lose job': 'Lose Job',
        'make a large purchase': 'Make a Large Purchase',
        'new job': 'Get a New Job',
        'oil shock': 'Oil Shock',
        'pay down debt': 'Pay Down Debt',
        'plan for education costs': 'Plan for Education Costs',
        'quit job': 'Quit Job',
        'receive inheritance': 'Receive Inheritance',
        retire: 'Retire',
        'save emergency fund': 'Save an Emergency Fund',
        'save for baby': 'Save for Family',
        'save for business': 'Save for Business',
        'save for college': 'Save for College',
        'save for education costs': 'Save for Education Costs',
        'save for home': 'Save for Home',
        'save for large purchase': 'Save for Large Purchase',
        'save for retirement': 'Save for Retirement',
        'save for vacation': 'Save for Vacation',
        'save for wedding': 'Save for Wedding',
        'take a vacation': 'Take a Vacation',
        windfall: 'Windfall'
    },
    GoalsDrawer: {
        '2008Crash': 'See what happens to your plan if we faced another economic downturn like 2008.',
        '2010boom': 'See what happens to your plan if the market and economy were to swing upward like 2010.',
        budgetExpenses: 'Forecast what would happen if you spent less (or more!) every month.',
        buyANewHome: 'See how much you can afford or set up a savings goal to help you get your dream home.',
        careForFamilyMember: 'See how caring for a family member in need will affect your financial plan.',
        collectSocialSecurity: 'Estimate how much you will receive and how it will affect your income.',
        donate: 'Figure out how much you can contribute to charity while still staying on track.',
        drawerDescription:
            'Drag and drop life events onto your timeline to model different scenarios, save for large expenses, and forecast your future.',
        endOfLife: 'Planning for difficult moments can help make sure your loved ones are taken care of.',
        getPromoted: 'Add a salary bump and see how it will affect your plan.',
        haveABaby: 'Factor in expected expenses for adding to your household. ',
        lifeInsurance:
            'Calculating what you think you’ll need will help determine how much to save and what it will cost you.',
        loseJob: 'Adding a loss of income will help you adjust your plan if you need to make changes.',
        makeALargePurchase:
            'Add a scenario that shows how making a large purchase will affect your plan. Want help saving? Set up a savings goal.',
        newJob: 'Understand the impact of a salary change to your plan.',
        noDebtTooltipText: 'You have no debt.',
        oilShock:
            'See what happens to your plan if there were a one-time drop in assets like the oil crisis in the 1970s.',
        payDownDebt: 'Lower your payments towards interest or debt and free up savings for other financial goals.',
        planForEducation: 'From tuition to meal plans, calculate how an investment in education will add up.',
        quitJob: 'Factor in how leaving your employer will affect your timeline.',
        receiveInheritance: 'See how an inheritance can impact your financial plan.',
        reduceExpenses: 'Forecast what would happen if you spent less (or more!) every month.',
        retire: 'Having a retirement year in mind can help you plan now to set yourself up for later on.',
        saveEmergencyFund: 'Life happens. Put away some savings in case of an emergency.',
        takeAVacation:
            'Planning a luxury trip or a local getaway? See how it will affect your plan or how much you’ll need to save.',
        validIncomeSourceTooltipText: 'You need a valid income source to play this card.',
        windfall: 'Add an unexpected financial gain.'
    },
    IncomeDrawer: {
        ConnectAccount: {
            buttonText: 'Connect Account',
            content1: "Connect your deposit accounts and we'll automatically calculate your after-tax incomes.",
            content2: 'This is the best way to experience $APP_NAME.',
            header: 'Connect An Income Account'
        },
        addButton: 'Add Income',
        addTitle: 'Add Income',
        amountInputHint: 'Your take home amount, after taxes and deductions',
        amountInputLabel: 'Income amount',
        editTitle: 'Edit Income',
        frequencyInputLabel: 'Income frequency',
        nameInputLabel: 'Income name',
        startDateInputLabel: 'Income start date',
        updateButton: 'Update Income'
    },
    IncomeExpenseDrawer: {
        cashFlowChartTitle: 'Cash flow by month',
        cashFlowMetricTitle: `$\{args[0] ? 'Projected' : ''} Cash Flow`,
        cashFlowTooltip: `$\{args[0] ? 'Projected cash' : 'Cash'} flow is the amount of money you are $\{args[0] ? 'projected to be' : ''} left with during your selected period (either month or year). Its value is $\{args[0] ? 'estimated using' : 'derived by the sum of'} your income, expenses, and effects of you life events.`,
        expenseMetricTitle: `$\{args[0] ? 'Projected' : ''} Expense`,
        expensesTitle: `$\{args[0] ? 'Projected' : ''} Expenses`,
        expensesTooltip: `Your $\{args[0] ? 'projected' : 'total'} expenses for your selected period$\{args[0] ? ' after life events' : ''}.`,
        incomeMetricTitle: `$\{args[0] ? 'Projected' : ''} Income`,
        incomeTitle: `$\{args[0] ? 'Projected' : ''} Income`,
        incomeTooltip: `Your $\{args[0] ? 'projected' : 'total'} income for your selected period$\{args[0] ? ' after life events' : ''}.`,
        projected: 'Projected Remaining',
        title: `Your Income & Expense Report for $\{args[0]}`,
        toDate: 'To Date',
        topDepositsTitle: `Top deposits $\{args[0] ? 'to date': ''}`,
        topDepositsTooltip: 'Your largest deposits across all accounts for the selected period.',
        topExpensesTitle: `Top expenses $\{args[0] ? 'to date': ''}`,
        topExpensesTooltip: 'Your largest expenses across all accounts for the selected period'
    },
    IncomeSourceModal: {
        addAnIncomeSource: 'Add an income source to group your transactions.',
        addIncomeSource: 'Add Income Source',
        alreadyExists: 'Income Source name already exists. Try using another name.',
        incomeSourceName: 'Income Source Name',
        incomeSourceNameRequired: 'Income source name is required',
        myJobSpousesJob: "My Job, Spouse's Job, Check, etc."
    },
    IncomesDrawer: {
        addButton: 'Add income',
        growthLearnMore: 'Learn more about income growth',
        growthRateBody: 'Change the rate your incomes grow year over year.',
        growthRateHeader: 'Income growth rate',
        growthTooltip:
            'Update the rate at which your income grows annually. This growth is not due to inflation but based on improvements to your earning power.',
        growthTooltipTitle: 'Income Growth',
        header: 'Last 12 Months Income',
        helpTooltip: 'Any and all positive cash deposits for the listed time period.',
        intro: `$\{args[0]} uses the last 12 full months of transaction history to create your income projections.`,
        learnMore: 'Learn more about projections',
        noIncomes: 'You have no income sources',
        outputTitle: 'Your Annual Income',
        sourcesHeader: 'Income Sources',
        titleFamily: "Your Family's Income",
        titleSingle: 'Your Income'
    },
    Ineligible: {
        anchorText: {
            americanExpressCards: 'American Express® Cards',
            email: 'an email on file'
        },
        basic: 'U.S. Basic Consumer Card Members',
        body: [
            'If you’re not currently one of the types of customers listed above, learn more about eligible ',
            '. For further support, please call the number on the back of your card.'
        ],
        checking: 'Rewards Checking customers',
        heading: '$BUDGETS_APP_NAME is only available to',
        rewardsChecking: 'Rewards Checking accounts offered by American Express National Bank. Member FDIC.'
    },
    InfoModal: {
        close: 'Close info modal'
    },
    InlineSyncError: {
        reconnect: 'Reconnect',
        tryAgain: 'Try again',
        unableToLink: 'Unable to link. ',
        unableToUpdate: 'Unable to update. '
    },
    Insights: {
        budgetRecap: {
            almostOverspending: ["You're ", 'close to overspending', ' in '],
            budget: ' budget',
            budgets: ' budgets',
            overspending: ["You're ", 'overspending', ' in '],
            underBudget: ["You're ", 'under', ' budget this month'],
            viewBudgets: 'View budgets'
        },
        getStarted: {
            addAccount: 'Add account',
            addBudget: 'Create a budget',
            addLifeEvents: 'Add life events',
            addYourAccounts: 'Add your accounts',
            buildOut: 'Customize your plan with more life events',
            checkOutYourIncome: 'Check your income projection details',
            connectAllYourFinancialInstitutions: 'Connect all your financial institutions for a holistic picture.',
            createBudget: 'Create Budget',
            getStarted: 'Get started with PlanAhead',
            learnAbout: 'Learn about, explore, and personalize your plan.',
            personalize: 'Personalize',
            personalizeYourPlan: 'Add life events to afford more of what you want during your lifetime.',
            setupBudget: 'Set up a budget to automatically track your expenses.',
            takeALook: 'See what you are projected to earn in the next year.',
            viewProjections: 'View projections'
        },
        newTransactionsRecap: {
            categorized: 'Categorized',
            newTransactions: 'New transactions',
            noDeposits: 'No deposits in this period.',
            noExpenses: 'No expenses in this period.',
            topDeposit: 'Top deposit',
            topExpense: 'Top expense',
            viewExpenses: 'View all expenses',
            viewIncome: 'View all income',
            viewTransactions: 'View all transactions'
        },
        planActions: {
            accountActionRequired: 'Account action required',
            accountReconnected: ' account needs to be reconnected',
            budgetAlert: 'Budget alert',
            budgetCategory: ' category',
            closeToOverspending: 'Close to overspending in ',
            dangerString: `Too much planned between $\{args[0]}`,
            dangerString2: 'Adjust timing of your events to balance your plan',
            dismiss: 'Dismiss',
            editLifeEvents: 'Edit life events',
            fixIt: 'Reconnect Account',
            overspending: 'Overspent this month in ',
            planActions: 'Actions',
            planActionsSub: 'Take these steps to help optimize your plan.',
            review: 'Review',
            saveToYourPrefix: `Reminder: Save $$\{args[0]} for `,
            saveToYourSuffix: ` by $\{args[0]}`,
            savingsGoalUnattached: ' is not associated with any account',
            savingsReminder: 'Savings reminder',
            transactionsSub: 'Transactions need review when they are outliers, checks, or uncategorized.',
            transactionsToReview: `$\{args[0]} $\{args[0] > 1 ? 'transactions' : 'transaction'} $\{args[0]} $\{args[0] > 1 ? 'need' : 'needs'} review`,
            viewBudget: 'View budget'
        },
        planRecap: {
            learnMore: 'Learn more about your plan status.',
            needNewCopy: 'Need new copy:',
            offTrack: 'Off Track',
            onTrack: 'On Track',
            yourPlanIs: 'Your plan is',
            yourPlanStatus:
                ' Your plan status is a comprehensive assessment of your financial landscape and the feasibility of your financial plan. '
        },
        savingsGoals: {
            addAnotherSavingsGoal: 'Add another Savings Goal',
            addLifeEvent: 'Add Life Event',
            haveASavingsGoalInMind: 'Have a savings goal in mind? Add the appropriate life event and get started.',
            ofTheWay: '% of the way to your goal',
            saveForEducationCosts: 'Save For Education Costs',
            saveForLargePurchase: 'Save for a Large Purchase',
            saveForRetirement: 'Save For Retirement',
            saved: ' saved',
            yourSavingsGoals: 'Your Savings Goals'
        },
        savingsRecap: {
            pctCloser: `You are $\{args[0]}% closer to your savings goals`,
            pctComplete: '% complete',
            warning: [
                'You’re not likely to meet your ',
                'Save for education',
                ', ',
                'Save for vacation',
                ', ',
                'Save for retirement goals',
                ' on time.'
            ]
        },
        statsBox: {
            changeInNetWorth: 'Change in net worth',
            investmentsChange: 'Investments change',
            savingsChange: 'Savings change'
        },
        suggestion: {
            addAccount: 'Add account',
            body: 'Add content here. No more than two lines. Add content here. No more than two lines. Add content here. No more than two lines.',
            connectYourOnlineAccounts: "'Connect your online accounts'",
            dimiss: 'Dismiss',
            positive: 'Positive',
            preTitle: 'Suggested based on your plan status:',
            refinanceYourDebt: 'Refinance your debt to lower your monthly payment'
        }
    },
    InvestmentDrawer: {
        Cash: {
            amountLabel: 'Cash amount',
            interestError: 'Rate is required',
            interestLabel: 'Interest rate'
        },
        Custom: {
            growthCallout:
                'Set the growth or appreciation rate with a positive percentage. Set depreciation rate with a negative percentage.',
            interestLabel: 'Annual asset growth rate'
        },
        RealEstate: {
            amountHint: 'The current or estimated value of your property',
            mortgageLabel: 'Have a mortgage for this property?',
            mortgageLink: 'Add asset & add a mortgage next'
        },
        Stock: {
            priceError: 'Price is required',
            priceHint: 'The current or estimated price per share',
            priceLabel: 'Price',
            priceMustBeGreaterThanZeroError: 'Price must be greater than 0',
            quantityError: 'Quantity is required',
            quantityLabel: 'Quantity',
            quantityMustBeGreaterThanZeroError: 'Quantity must be greater than 0',
            tickerError: 'Ticker not found',
            tickerLabel: 'Ticker',
            totalTitle: 'Total'
        },
        addTitle: 'Add Banks, Investments, and Assets',
        amountInputError: 'Total is required',
        amountMustBeGreaterThanZeroError: 'Total must be greater than 0',
        assetTypeError: 'Type is required',
        assetTypeLabel: 'Type of bank, investment, or asset',
        balanceLabel: 'Current balance',
        nameInputError: 'Name is required',
        nameInputLabel: 'Name or nickname',
        priceLastUpdated: 'Price last updated: today at 9:35am',
        updateTitle: 'Update Banks, Investments, and Assets',
        valueLabel: 'Current value'
    },
    JobDeltaDrawer: {
        incomeSourceLabel: 'Which job or income is getting the promotion?',
        intro: 'Add a salary bump to see how it will affect your plan. If you get promoted, we assume a 15% salary gain over the current income in your plan (which we display below as a default).',
        intro2: 'This income grows at the rate you set during onboarding. You can edit this amount at any time in your financial profile.',
        takeHome:
            "If you'd like to put an amount other than what's defaulted, make sure to enter the take-home pay amount."
    },
    JobPicker: {
        noIncome: 'You have no income'
    },
    Landing: {
        heading: '',
        subheading: ''
    },
    LargePurchaseDrawer: {
        intro: 'Add a scenario that shows how making a large purchase will affect your plan. Want help saving? Set up a savings goal.',
        startDate: 'When do you want to make your purchase?'
    },
    LifeInsuranceDrawer: {
        intro: 'Life insurance is a complex area and there are many different types of policies. This tool uses a sample model to help you estimate your potential life insurance expenses and payouts to beneficiaries. Term life insurance, which expires after the term length, is a cost-effective option. We suggest that you consult with a licensed broker to identify the right policy for you.'
    },
    LinkExternalAccountBody: {
        description: 'Want to see your full spending history?',
        link: 'Link more accounts'
    },
    LinkExternalAccountCallout: {
        body:
            'Get a fuller view of your overall spending habits by linking your consumer credit cards and' +
            ' checking accounts from other financial institutions. ',
        button: 'Link Accounts',
        header: 'Want to see your full spending history? Link more accounts.'
    },
    Loader: {
        accountLine1: 'Syncing your accounts...',
        accountLine2: 'This may take up to five minutes.'
    },
    LoseJobDrawer: {
        lose: {
            incomeSourceLabel: 'Which job or income do you plan to lose?'
        },
        quit: {
            incomeSourceLabel: 'Which job or income do you want to quit?'
        },
        retire: {
            incomeSourceLabel: 'Which job or income do you want to retire from?'
        }
    },
    ManageRulesHeader: {
        createRuleButton: 'Create Rule',
        description:
            'You can add a new rule for any keywords or phrases in a transaction name or merchant name. You can also edit or delete an existing rule.',
        title: 'Manage Rules'
    },
    ManageRulesView: {
        subtitle:
            'Rules let you select categories for similar transactions, then automatically apply those selections to existing and future auto-categorized transactions.',
        title: 'Transaction Rules'
    },
    Mentors: {
        AccountsShortMessage: {
            assets: 'Looks like your assets are a bit lower than you told us when you entered it manually, do you have any other asset accounts to add?',
            debts: 'Looks like your debt is a bit lower than you told us when you entered it manually, do you have any other debt accounts to add?',
            depository:
                'Looks like your savings are a bit lower than you told us when you entered it manually, do you have any other savings or checking accounts to add?',
            expenses:
                'Looks like your expenses are a bit lower than you told us when you entered it manually, do you have any other expense accounts to add?',
            income: 'Looks like your income is a bit lower than you told us when you entered it manually, do you have any other income accounts to add?',
            property:
                'Looks like your property value is a bit lower than you told us when you entered it manually, do you have any other properties to add?'
        },
        AccountsToAdd: {
            accountsMatch: `Your $\{args[0]} $\{args[1] ? 'matches' : 'match'} what you told us when you entered it manually`,
            assets: ' but your assets are still low, do you have any other asset accounts to add?',
            debts: ' but your debts are still low, do you have any other debt accounts to add?',
            depository: ' but your savings are still low, do you have any other savings or checking accounts to add?',
            expenses: ' but your expenses are still low, do you have any other expense accounts to add?',
            income: ' but your income is still low, do you have any other income accounts to add?',
            property: ' but your property values are still low, do you have any other properties to add?'
        },
        AddAccounts: {
            buttonOne: 'Add more accounts',
            buttonTwo: "I've added everything",
            header: 'Have you added all your accounts?'
        },
        DangerBar: {
            body1: "See this bar on your timeline? It's a warning that shows when your plan is out of balance.",
            body2: 'Seeing an orange warning means you are spending into your savings to cover your expenses and life events.<br/><br/>Seeing a red warning means you are out of cash and savings and will need to sell assets, take out equity, sell property, or accrue more debt to cover your costs.',
            body3: 'To get your plan back in balance you can increase your income, reduce the cost of your life events, or move the date of any life event until you can afford it.',
            buttonOne: 'Next'
        },
        Default: {
            body: "Welcome to $APP_NAME, Matthew! I'm mentor. I'll be one of your mentors, here to help you live the life you want to.",
            buttonOne: 'Continue',
            buttonTwo: 'Cancel',
            header: 'Welcome!'
        },
        FirefoxWarning: {
            body: '$APP_NAME uses certain technologies that are not supported by Firefox. For the best experience, use Chrome, Brave, or Safari browsers.',
            buttonOne: 'Dismiss',
            header: 'Firefox is not fully supported.'
        },
        FirstDrag: {
            body: 'Moving any life event on your timeline will adjust your plan and show you the effects in real-time.',
            buttonOne: 'Dismiss',
            header: 'First drag'
        },
        MoreAccountsBody: {
            debtsAssetsProperty: `<b>$\{args[0]}</b> is now added to $APP_NAME.`,
            institution: `$\{args[0]} is now connected to $APP_NAME and your $\{args[1]} $\{args[2] ? 'accounts are' : 'account is'} being synced.`,
            otherAccounts: 'Do you have any other accounts to add?'
        },
        Save: {
            body: "Looks like you're an explorer after all. If you want to jump back in, click on my avatar here."
        },
        TakeVacation: {
            body: "When you're ready, drag Take a vacation into the tray at the bottom of the screen.",
            buttonOne: "I'm ready",
            header: 'Try out a $APP_NAME goal by planning a vacation.'
        },
        Tour: {
            Step1: {
                OffTrack: {
                    body: 'Based on the info you’ve provided so far, your plan is off track and your life events might not be possible within your current financial situation. Add any additional accounts to make sure we have your full financial picture.<br><br>Take a quick look at what you can do next...',
                    header: 'Your plan is off track'
                },
                OnTrack: {
                    body: 'Based on the info you’ve provided so far, your plan is on track and your life events are possible within your current financial situation.<br><br>Take a quick look at what you can do next...',
                    header: 'Your plan is on track'
                },
                buttonOne: 'Take tour',
                buttonTwo: 'Skip tour'
            },
            Step2: {
                body: 'Your plan status gives you an at-a-glance view of the health of your plan. On track indicates your plan is just that, on track. Off track indicates something might not be quite right with your plan.'
            },
            Step3: {
                body: 'Continue to personalize your plan by adding the life events most relevant to you.'
            },
            Step4: {
                body: 'Your Financial Profile includes the income, expenses, accounts, and family that influence your projections and plan.'
            },
            Step5: {
                body: 'Review our Insights to find the latest changes in your plan along with suggestions and actions to keep or get your plan on track.'
            },
            Step6: {
                body: 'Set up a personalized budget to get a closer look at your monthly spending or to help you reduce your spending category by category.'
            },
            Step7: {
                body: 'You’re off to a great start. Continue personalizing and refining your plan.',
                buttonOne: 'Refine My Plan',
                header: 'Finish personalizing your plan'
            },
            buttonOne: 'Next',
            buttonTwo: 'End tour'
        },
        UnsavedBudget: {
            body: "You'll lose this budget if you go back. Are you sure?",
            buttonOne: 'Continue editing',
            buttonTwo: 'Go back',
            header: 'You have unsaved changes'
        },
        newJob: {
            body: `We'll model what it looks like if you get a new job in $\{args[0]} years, with an assumed 15% salary increase.`
        },
        notNow: 'Not now'
    },
    MonthlySpendingBudget: {
        header: 'Spending by category this month'
    },
    NetWorthDrawer: {
        amountTitle: 'Adjustment amount',
        assets: 'Assets',
        assetsCount: `$\{args[0]} assets`,
        debts: 'Debts',
        debtsCount: `$\{args[0]} debts`,
        netWorthMetricTitle: `$\{args[0] ? 'Projected' : ''} Net worth`,
        netWorthTooltip: 'The value of your assets minus your debts.',
        projection: 'Projections',
        reportTitle: `Your Net Worth Report for $\{args[0]}`,
        title: 'Your net worth',
        yourAssets: 'Your assets',
        yourDebts: 'Your debts'
    },
    NewJobDrawer: {
        intro: 'Understand the impact of a salary change to your plan. If you change jobs, we assume a 15% salary gain over the current income in your plan (which we display below as a default).',
        intro2: 'This income grows at the rate you set during onboarding. You can edit this amount at any time in your financial profile. Make sure to add the Quit Job life event.',
        introLink: 'Learn about how we project income.',
        takeHome:
            'If you’d like to put an amount other than what’s default, make sure to enter the take-home pay amount.'
    },
    NewScenarioDialog: {
        body: 'Scenarios allow you to create multiple plans so that you can compare different combinations of life events. Learn more about scenarios.',
        create: 'Create new scenario',
        'create-date': 'Create a new scenario from an existing date',
        'create-empty': 'Create a brand new scenario',
        'create-plan': 'Create a new scenario from your existing plan',
        'explain-date': 'Create a new scenario from an existing date.',
        'explain-empty': 'Start fresh with no existing life events (except End of Life).',
        'explain-plan':
            'Use your existing plan as a starting point. Any changes will be applied only to your new scenario.'
    },
    Onboarding: {
        '401k': '401k',
        '401kTitle': 'Add a 401K account',
        addAccounts: {
            '401kAnd403b': '401K / 403B',
            autoLoan: 'Auto Loan',
            bonds: 'Bonds',
            cash: 'Cash',
            certificateOfDeposit: 'Certificate of Deposit (CD)',
            checkingAccount: 'Checking account',
            creditCardDebt: 'Credit Card Debt',
            cryptocurrency: 'Cryptocurrency',
            customPropertyAndAsset: 'Custom (collectibles, jewelry, art)',
            education: '529 - Education account',
            highYieldSavingAccount: 'High yield saving account',
            homeEquityLoan: 'Home Equity Loan',
            ira: 'IRA',
            mortgage: 'Mortgage',
            mutualFundsAndPublicStocks: 'Mutual funds / public stocks',
            otherCashAndBanking: 'Other',
            otherDebt: 'Other',
            otherInvestmentsAndRetirement: 'Other',
            pension: 'Pension',
            personalLoan: 'Personal Loan',
            privateStock: 'Private Stock',
            realEstate: 'Real Estate',
            savingAccount: 'Saving account',
            studentLoan: 'Student Loan',
            title: 'Add Accounts',
            vehicle: 'Vehicles'
        },
        addManually: 'Add your info manually',
        annualIncome: 'annual income',
        avgExpenses: 'Avg. annual expenses',
        back: 'Back',
        buyHouse: {
            cardDescription: 'buy new home',
            cname: 'goalBuyHouse',
            description: 'First time or second time buyer. Use this.',
            iconName: 'buy new home',
            label: 'Buy a house',
            track: 'o4 Buy House'
        },
        callYou: 'What we should call you',
        cashAndBanking: {
            addCheckingSubtitle: 'Add any available checking accounts',
            addCheckingTitle: 'Checking account',
            addHysaSubtitle: 'High yield or high interest savings accounts',
            addHysaTitle: 'High yield savings account',
            addSavingSubtitle: 'Basic and online savings accounts',
            addSavingTitle: 'Savings account',
            calloutBody:
                'Connect your financial accounts for real-time deposits, spending, and automatically updating balances.',
            calloutHeading: 'Connect your financial institutions',
            formCalloutBody:
                'Get the most out of PlanAhead by connecting your bank accounts. See automatic updates to your balances, interest rates, and more.',
            formCalloutHeading: 'Add your cash and banking accounts',
            listAccountsHeading: 'Your Cash & Savings Accounts',
            otherTitle: 'Other cash or bank accounts',
            title: 'Add Cash & Banking'
        },
        connectAccount: 'Connect an account',
        connectAccountExpenses: 'Connect an account for precise expense totals.',
        connectAccountIncome: 'Connect an account for precise income amounts.',
        connectAccountSavings: 'Connect an account for real time savings balances.',
        connectAccounts: {
            bullets: [
                'Make your plan more accurate with your complete financial profile',
                'Gain more control over your projections',
                'Your balances stay up-to-date automatically',
                'See if you’re overspending in real time',
                ['It’s easy and safe. $APP_NAME uses ', 'Plaid', ' to securely connect to your financial institutions']
            ],
            footer: 'Read our privacy & data sharing policies',
            header: 'Why should you connect?',
            whyShouldYouConnect: 'Why should you connect?'
        },
        connectEducation: 'Connect an account for precise education balances.',
        connectProperty: 'Connect an account for precise debt balances',
        connectRetirement: 'Connect an account for real time retirement balances.',
        connectTabDesc: 'Connecting and syncing your accounts is the best way to experience $APP_NAME.',
        connectTabList1: 'Gain more control over your projections',
        connectTabList2: 'Your balances stay up-to-date automatically',
        connectTabList3: 'See if you’re overspending in real time',
        connectTabList4: 'It’s easy and safe. $APP_NAME uses Plaid to securely connect to your financial institutions',
        connectTabSubtitle: 'Why should I connect?',
        connectTabTitle: 'Connect an account',
        debt: 'Current debt',
        debtDesc: 'Add the current market value of any property you currently own.',
        debtTitle: 'Add debt',
        dontConnectYet: 'Don’t want to connect quite yet?',
        education: 'Education savings',
        educationAssets: 'Education assets',
        educationTabDesc: '529s, ESAs, or other education restricted accounts.',
        educationTabTitle: 'Because you’re planning for education…',
        educationTitle: 'Add an education savings account',
        expenses: {
            accountsSubtitle: 'Select the accounts to include in your plan',
            accountsTitle: 'Your expense accounts',
            accountsTooltip: 'Need to be filled',
            additionalMonthlySpendingDesc: 'Total monthly expenses not purchased with your American Express Cards',
            additionalMonthlySpendingTitle: `Your $\{args[0]} additional monthly spending`,
            connectAccountDesc:
                'Connect your accounts for real-time deposits, spending, automatically categorized transactions, and the ability to create budgets.',
            connectAccountTitle: 'Want real-time spending info?',
            description:
                'Expenses are what your family income is spent on every month. Including but not limited to mortgage or rent payments, utilities, food, clothing, and entertainment.',
            needInfo: 'Need info',
            next: 'Next: Add Cash & Savings',
            outputHeading: 'Your average monthly spending',
            title: 'Add Your Expenses'
        },
        extraAccounts: `Plus $\{args[0]} other non $\{args[1]} account$\{args[0] === 1 ? '' : 's'}.`,
        familyIncomes: 'Add your family’s incomes',
        forms: {
            at: ' at ',
            inputHints: {
                infoCallout:
                    'Set the growth or appreciation rate with a positive percentage. Set depreciation rate with a negative percentage.',
                theCurrentOrEstimatedValueOfYourProperty: 'The current or estimated value of your property',
                theInitialAmountOfYourLoan: 'The initial amount of your loan'
            },
            inputLabels: {
                annualGrowthRate: 'Annual growth rate',
                cashAmount: 'Cash Amount',
                coinQuantity: 'Coin Quantity',
                currencyName: 'Currency Name',
                currentBalance: 'Current Balance',
                currentValue: 'Current Value',
                interestRate: 'Interest Rate',
                loanDuration: 'Loan duration',
                name: 'Name',
                originalLoanAmount: 'Original loan amount',
                originalLoanTerms: 'Original loan terms',
                originalMortgageTerms: 'Original mortgage terms',
                price: 'Price',
                quantity: 'Quantity',
                startDate: 'Start date',
                ticker: 'Ticker'
            },
            inputValidationNull: 'Please provide a value',
            inputValidationTypeNumber: 'Please provide a number',
            months: 'months',
            on: 'on',
            priceLastUpdated: 'Price last updated: ',
            today: 'today',
            total: 'Total'
        },
        goalEducation: `$\{args[0]}'s Education, Age 18`,
        goalRetire: `Retire $\{args[0]}`,
        growFamily: {
            cardDescription: 'have a baby',
            cname: 'goalGrowFamily',
            description: 'See the impact of adding a new family member.',
            iconName: 'have a baby',
            label: 'Grow a family',
            track: 'o4 GrowFamily'
        },
        homeTabDesc: 'Add any existing property you own including any debt you owe against those properties.',
        homeTabTitle: 'Because you’re planning to buy a home…',
        incomes: {
            annualPretaxIncome: 'annual pre-tax income',
            anyIncomeTied: 'Any income tied to this individual',
            basedOn: 'Based on your American Express info',
            connectYourAccounts:
                'Connect your accounts for real-time deposits, spending, automatically categorized transactions, and the ability to create budgets.',
            enterTheAnnual:
                'Enter the annual pre-tax income of the family members you are including in your plan. This can be salary, wages, or any other deposits you get on a recurring basis.',
            header: 'Add Your Income',
            howWeCalculate: 'How we calculate income',
            incomeNotTiedTo: 'Income not tied to a specific individual',
            learnMoreAbout: 'Learn more about incomes',
            next: 'Next: Add Expenses',
            otherRecurringIncome: 'Other recurring pre-tax income',
            wantUptodateInfo: 'Want up-to-date income information?',
            yourAnnualIncomes: 'Your annual incomes (after taxes)'
        },
        incomesTabDesc:
            'Enter the income of the family members you are including in your plan. This can be salary, wages, or any other deposits you get on a recurring basis.',
        incomesTabDesc2:
            'Enter the income of the family members you are including in your plan. This can be salary, wages, or any other deposits you get on a recurring basis. Ballpark numbers are ok!',
        incomesTabPlus: `Plus $\{args[0]} other non-income accounts`,
        investmentsAndRetirement: {
            addCryptoSubtitle: 'Any crypto curriencies you own',
            addCryptoTitle: 'Cryptocurrencies',
            addEducationSubtitle: '529s, ESAs, or other education restricted accounts',
            addEducationTitle: '529 - Education account',
            addIraSubtitle: 'Roth, Savings, and other IRA types',
            addIraTitle: 'IRAs',
            addMutualFundsAndPublicStocksSubtitle: 'Add mutual funds or any publicly trades stocks',
            addMutualFundsAndPublicStocksTitle: 'Mutual Funds or Public Stock',
            addPensionSubtitle: 'Employer based pension',
            addPensionTitle: 'Pension',
            addRetirementSubtitle: '401K, 403B, and other retirement accounts',
            addRetirementTitle: 'Retirement account',
            formCalloutBody:
                'Get a better picture of your financial future when you connect your investment and retirement accounts. See automatic updates to balances, pricing, and values directly in PlanAhead.',
            formCalloutHeading: 'Add your investment and retirement accounts',
            listAccountsHeading: 'Your Investments & Retirement',
            otherTitle: 'Other investment accounts',
            title: 'Add Investments & Retirement'
        },
        ira: 'IRA',
        iraTitle: 'Add an IRA account',
        largePurchase: {
            cardDescription: 'make a large purchase',
            cname: 'goalLargePurchase',
            description: 'From buying a car to saving for a wedding.',
            iconName: 'make a large purchase',
            label: 'Make a large purchase',
            track: 'o4 Large Purchase'
        },
        loansAndDebt: {
            addAutoLoanSubtitle: 'Any current auto debt',
            addAutoLoanTitle: 'Auto Loans',
            addCreditCardSubtitle: 'Any current credit card debt',
            addCreditCardTitle: 'Credit Card Debt',
            addMortgageSubtitle: 'Mortgages for any property you own',
            addMortgageTitle: 'Mortgage',
            addPersonalLoanSubtitle: 'Any current education debt',
            addPersonalLoanTitle: 'Personal Loans',
            addStudentLoanSubtitle: 'Any current auto debt',
            addStudentLoanTitle: 'Student Loans',
            formCalloutBody:
                'Connect your loan accounts to see automatic updates to your balances and interest rates in PlanAhead.',
            formCalloutHeading: 'Connect a loan account',
            listAccountsHeading: 'Your Loans & Debts',
            otherTitle: 'Other debt',
            title: 'Add Loans & Debts'
        },
        manualIncome: 'Add a manual income',
        meetYourPlan: {
            description:
                'Your plan is a timeline of your life with personalized Life Events that align with your financial goals. Each event is placed relative to you and your family member’s age.',
            list1Part1: 'Drag ',
            list1Part2: 'to adjust the date of your Life Events',
            list2Part1: 'Click into a Life event ',
            list2Part2: 'to adjust its details and values',
            next: 'Next: Add Income',
            optionsBoxTitle: 'Try out your life events',
            projections:
                'Your projections will get more accurate as you add your financial data and connect additional accounts in the upcoming steps.',
            title: `Meet your plan$\{args[0]}`,
            whenReady: 'When you’re ready to add your financial data, click next.'
        },
        myFamily: 'Me & my family',
        next: 'Next',
        nextAddIncome: 'Next: Add Income',
        nonRestricted: 'Non-restricted investments',
        nonRestrictedDesc: 'Any non-restricted assets available for discretionary spending.',
        nonRestrictedTitle: 'Add a non-restricted investment',
        optional: '(optional)',
        other: 'Other retirement savings',
        otherEducation: 'Other savings suitable for education needs.',
        otherRecurringIncome: 'Recurring income not associated with an individual',
        otherTitle: 'Add a retirement account',
        pension: 'Pension',
        pensionTitle: 'Add a pension account',
        planEducation: {
            cardDescription: 'plan for education costs',
            cname: 'goalPlanForEducation',
            description: 'College tuition, private school, or daycare.',
            iconName: 'plan for education costs',
            label: 'Plan for education expenses',
            track: 'o4 Plan For Education'
        },
        planRetirement: {
            cardDescription: 'retire',
            cname: 'goalRetire',
            description: 'Plan for retirement for you and your family.',
            iconName: 'retire',
            label: 'Plan for retirement',
            track: 'o4 Retire'
        },
        preTax: '(pre-tax amount)',
        privacy: 'Privacy Policy',
        privacyTerms: 'By signing in you agree to our',
        property: 'Existing property',
        property2: 'property',
        propertyAndAssets: {
            addCustomPropertyAndAssetSubtitle: 'Art, jewelry, baseball cards, or other collectibles',
            addCustomPropertyAndAssetTitle: 'Custom asset',
            addRealestateSubtitle: 'Any real estate property you own',
            addRealestateTitle: 'Home, condo, or investment properties',
            addVehicleSubtitle: 'Cars, motorcycles, boats, or other vehicles',
            addVehicleTitle: 'Vehicles',
            formCalloutBody:
                'Get the most out of PlanAhead by connecting property and asset accounts. See automatic updates to your balances, pricing, and values.',
            formCalloutHeading: 'Connect property and asset accounts',
            listAccountsHeading: 'Your Property & Assets',
            title: 'Add Property & Assets'
        },
        propertyDesc: 'Add the current market value of any property you currently own.',
        propertyTitle: 'Add property',
        propertyValue: 'Property value',
        recurringIncome: 'Other recurring income',
        retirementAndInvestments: {
            anyCryptoCurriencies: 'Any crypto curriencies you own',
            cashCheckingAndLowinterest: 'Cash, checking, and low-interest bearing accounts',
            cryptoCurrencies: 'Crypto currencies',
            employerBasedPension: 'Employer based pension',
            heading: 'Add Retirement & Investments',
            investmentAccount: 'Investment account',
            mutualFundsMoneyMarket: 'Mutual Funds, Money Market, online trading',
            otherInvestmentAccounts: 'Other investment accounts',
            pension: 'Pension',
            retirementAccount: 'Retirement account'
        },
        retirementAssets: 'Retirement assets',
        retirementTabDesc: `Add your retirement specific assets so we can understand $\{args[0]} retirement situation.`,
        retirementTabTitle: 'Because you’re planning for retirement…',
        saveTabDesc: `Ready to save your plan? Create your free $\{args[0]} account.`,
        saveTabList0: 'With a $APP_NAME account you’ll be able to:',
        saveTabList1: 'Come back to view and edit your plan any time',
        saveTabList2: 'Connect your online accounts',
        saveTabList3: 'Create savings goals and track your savings progress',
        saveTabList4: 'View all your transactions by account, date, and type',
        saveTabList5: 'Create a personalized budget',
        saveTabList6: 'Access better projection controls',
        saveTabTitle: 'Save your plan',
        saveTabTitle2: `In order to connect your online accounts you need a $\{args[0]} account.`,
        savings: 'Savings',
        savingsDesc: 'Traditional depository, high yield savings accounts, or cash on hand.',
        savingsTabDesc:
            'Add any savings you have available. Do not include restricted assets or savings set aside for retirement.',
        savingsTabTitle: 'How much do you have in savings?',
        savingsTitle: 'Add a savings account',
        skip: 'Skip for now',
        takeVacation: {
            cardDescription: 'take a vacation',
            cname: 'goalVacation',
            description: 'What can you afford and when?',
            iconName: 'take a vacation',
            label: 'Take a vacation',
            track: 'o4 Vacation'
        },
        terms: 'Terms & Conditions',
        totalAnnualIncome: 'Total annual income',
        totalNetworth: 'Total net worth',
        totalSavings: 'Total savings',
        updateExpenses: 'Want to add your real-time spending?',
        updateIncome: 'Want up-to-date income information?',
        updateSavings: 'Looking to keep your balances in sync?',
        upload: 'Upload a photo',
        uploadNeed: 'You can add or change photos at anytime later',
        welcome: {
            subtitle: 'Start building your ideal financial plan.',
            tabDescPart1: 'Select as many goals as you’d like. ',
            tabDescPart2: 'You can change your goals at any time later.',
            title: `Welcome to $\{args[0]}.`
        },
        who: {
            justMe: 'Just me',
            justMeDesc: 'For solo planners',
            myselfOthers: 'Myself and others',
            myselfOthersDesc: 'For planning with a family, partner, parents, or more',
            tabDesc:
                'Add the people in your life that you want to include in your plan. We call it your family, but you don’t have to be related. Add your partner, spouse, children, parents, or anyone you want to plan with.',
            title: 'Who are you planning for?'
        },
        whoelse: {
            addFamilyButton: 'Add Family',
            addFamilyContent: 'Add a partner, spouse, child, and more.',
            addFamilyHeader: 'Add a family member',
            addUpdatePhoto: `$\{args[0] ? 'Update' : 'Add'} photo`,
            next: 'Meet your plan',
            tabDesc:
                'Add the people in your life that you want to include in your plan. We call it your family, but you don’t have to be related. Add your partner, spouse, children, parents, or anyone you want to plan with.',
            title: 'Who else are you planning for?'
        },
        your: 'Your',
        yourData: 'Learn about how you own and control your data',
        yourDob: 'Your birth date',
        yourDobNeed: 'We need your birth date to size your plan appropriately',
        yourLower: 'your',
        yourName: 'Your name or nickname',
        yourselfTabDesc: 'We need to know just a few things about you before we get started.',
        yourselfTabTitle: 'Tell us about yourself'
    },
    PageOrientation: {
        basedOn: 'Based on ',
        currentMonth: {
            title: 'Current Month'
        },
        daysRemaining: ' Days remaining',
        lastYear: {
            title: 'Last 12 Months'
        },
        linkAndManageAccounts: 'Link & Manage Accounts',
        numAccounts: `$\{args[0]} account$\{args[0] === 1 ? '' : 's'}`
    },
    PayDownDebtDrawer: {
        intro: 'We define high interest debt as anything above 5%. Paying down this debt first reduces your overall interest payments for your debt. See how paying more on your debt every month affects your plan.<br/><br/>Paying down your highest interest debt first is a good way to reduce your monthly debt payments.',
        introLink: 'Learn more about our pay down methodology.',
        title: `You can afford to pay an additional $\{args[0]} per month.`,
        title2: 'How much do you want to pay in addition to your minimum payments?',
        update: 'Update'
    },
    PersonDialog: {
        child: 'Child',
        chooseRelationship: 'Choose Relationship',
        dob: 'Date of birth',
        familyMember: 'family member',
        other: 'Other',
        parent: 'Parent',
        partner: 'Partner',
        planOwner: 'Plan owner',
        sibling: 'Sibling',
        spouse: 'Spouse'
    },
    PlanDrawer: {
        signup: 'Connect your accounts to get the most out of $APP_NAME',
        startSteps: "Start $APP_NAME's 7 Steps to Financial Independence",
        stepNumber: `$\{args[0]} of $APP_NAME's 7 Steps to Financial Independence is now available`,
        temporary: 'Sign up for $APP_NAME to save your plan'
    },
    PlanForEducationCostsDrawer: {
        amountForTime: `Total amount for $\{args[0]}`,
        baselineSavingsTooltip:
            'Baseline savings is the difference between your projected income and projected expenses added up year over year. This cannot be unselected.',
        intro: 'Add a scenario that calculates expected education costs. Don’t have the money yet? Add an optional savings goal.',
        totalCost: `Total amount for $\{args[0]} of tuition`
    },
    ProfilePersonCard: {
        editProfile: 'Edit info',
        planOwner: 'Plan Owner'
    },
    ProgressTile: {
        headline: 'You are $progress closer to your savings goals'
    },
    RetireDrawer: {
        goodNever: 'You will likely have enough money during retirement.',
        runOutAge: `You will likely run out of money by age $\{args[0]}.`,
        startDate: 'When do you plan to retire?'
    },
    ReturningDialog: {
        budgetText: "You're overspending in 6 budgets",
        emphasizedWord: 'overspending',
        headlineSinceLogin: 'In the last 30 days',
        headlineThisWeek: "This week's updates",
        viewMoreText: 'View more insights'
    },
    ReviewTransactionsDrawer: {
        headerPart1: 'Review your transactions, make any changes and then click ',
        headerPart2: ' to approve.',
        headerSubText:
            'Since we couldn’t match these expenses to an existing category or because they were higher than usual, you should review them to keep your plan accurate. To find out more about each transaction, click on the info icon.'
    },
    Rule: {
        alreadyExists: 'This rule already exists. Try creating a different rule.',
        apply: 'Apply',
        applyRule: 'Apply Rule',
        containsText: 'contains',
        deleteRule: 'Delete Rule',
        doesNotMatchTransaction:
            'This rule is unrelated to this transaction, but will be applied to relevant transactions. Once created, you can see this rule with your other Transaction Rules.',
        endsWithText: 'ends with',
        equalsText: 'is exact match for',
        name: `If transaction name $\{args[0]} "$\{args[1]}", then move to "$\{args[2]}" rule.`,
        startsWithText: 'starts with'
    },
    RuleInfoModal: {
        anchorTitle: 'Learn about how rules work',
        point1: 'If multiple rules have the same keyword, only the rule that’s higher on the list will be applied.',
        point2: 'Drag to rearrange the order in which your rules are applied.',
        point3: 'Any changes you make to existing rules will automatically apply to existing and future transactions, except for those that have already been recategorized manually.',
        title: 'How rules work'
    },
    RulePrompt: {
        close: 'Close',
        createRule: 'Create Rule',
        heading: `Always move transactions containing <b>$\{args[0]}</b> to <b>$\{args[1]}</b>?`,
        manageRules: 'Manage Rules',
        neverAskAgain: {
            text1: "You won't see these Create Rule messages again.",
            text2: "If you'd like to see these messages, change your settings in ",
            text3: "Didn't mean to do this? "
        },
        neverAskToCreateRule: 'Never ask to create rules',
        success: {
            text1: 'You successfully created a rule',
            text2: 'View, edit, create, or delete any transaction rules in ',
            text3: "Didn't mean to do this? "
        },
        undo: 'Undo'
    },
    RuleRow: {
        applyRuleButton: 'Apply Rule',
        categoryOfRule: 'Category of rule',
        containsOption: 'Contains',
        endsWithOption: 'Ends with',
        equalsOption: 'Exact match for',
        if: 'If name',
        matchCriteriaOfRule: 'Match criteria of rule',
        moveTo: 'move to',
        namePlaceholder: 'Keyword, phrase, or merchant name',
        selectCategory: 'Select Category',
        startsWithOption: 'Starts with',
        textToMatchOfRule: 'Transaction name of rule',
        this: 'this'
    },
    RuleSetting: {
        askToCreateRule: 'Always ask to create a rule',
        description:
            'After recategorizing a transaction, you will be asked if you’d like to create a rule for all' +
            ' similar transactions.',
        title: 'Settings',
        toggleOff: 'Toggle is off for asking to create rules',
        toggleOn: 'Toggle is on for asking to create rules'
    },
    SalaryInput: {
        title: 'Annual Salary',
        tooltipBody: 'Based on the current income in your plan'
    },
    SavingsDrawer: {
        change: 'Adjust life event',
        education: {
            costText: 'Total cost for room, board, and books after financial aid.',
            costTextLinked: `Total cost for $\{args[0]} with room, board, and books after financial aid.`
        },
        family: {
            costText: `Based on a child's date of birth of $\{args[0]}.`
        },
        home: {
            costText: `Based off an estimated $\{args[0]} down payment for a home purchase in $\{args[1]}.`
        },
        large: {
            costText: `Based on a purchase planned for $\{args[0]}.`
        },
        learnAbout: 'Learn about how we calculate this value',
        met: 'You’ve met your goal.',
        notComfortableSave: 'You can’t comfortably save this much every month.',
        notOnTime: 'You won’t meet your savings goal in time.',
        onTime: 'You’ll meet your savings goal on time.',
        perMonthNeeded: `To meet your goal on time, you’ll need to save a minimum of $\{args[0]} per month. We project you'll have an average of $\{args[1]} available to save every month.`,
        percentSaved: `$\{args[0]}% of the way to your goal`,
        retirement: {
            costText: `Based off a planned retirement in $\{args[0]}.`
        },
        savePerMonth: 'How much do you want to save per month?',
        savings: {
            costText: `Based on a purchase planned for $\{args[0]}.`
        },
        update: 'Update',
        vacation: {
            costText: `Based off an planned vacation in $\{args[0]}.`
        }
    },
    SavingsGoals: {
        largePurchase: `Save For $\{args[0]}`
    },
    Scenarios: {
        cancel: 'Cancel',
        create: 'Create',
        default: 'Default plan',
        name: 'Name your new scenario',
        new: 'New scenario name',
        rename: 'Rename your scenario',
        'rename-button': 'Rename'
    },
    SecondaryNavigation: {
        FAQs: 'FAQs',
        secondaryNav: 'Secondary Navigation',
        settings: 'Settings',
        spendSmart: 'SpendSmart™',
        transactions: 'Transactions'
    },
    SelectCard: {
        selectButton: 'Select'
    },
    ShowSubcategoryButton: {
        hide: 'Hide subcategories',
        show: 'Show subcategories'
    },
    ShowWork: {
        adjustments: 'Life event adjustments',
        tooltip: 'How your life events have impacted your plan.'
    },
    ShowWork2: {
        baseline: 'The difference between your projected income and projected expenses added up year over year.'
    },
    SpendingBreakdown: {
        avgMonth: 'Avg. mo: ',
        avgMonthFull: 'Avg. month: '
    },
    SpendingCategories: {
        avgMonth: `Avg. month: $\{args[0]}`,
        basedOn:
            'Monthly averages are calculated based on the typical spending in your accounts for up to the last 12 full months. Totals include typical and one-time transactions.',
        ofTotal: `$\{args[0]} of total`,
        spendingByCategory: 'Spending by category this month',
        totalYearlySpending: 'Total yearly spending by category'
    },
    SpendingOverview: {
        percentOfTotal: `$\{args[0]} of total`
    },
    SpentRemaining: {
        exceeding: 'Exceeding:  ',
        remaining: 'Remaining: '
    },
    StatsBox: {
        categorized: 'Categorized',
        deposit: 'Top deposit',
        expense: 'Top expense',
        investments: 'Investments change',
        investmentsAction: 'Visit our Returning user dialog article to learn more.',
        investmentsTooltip:
            '$APP_NAME uses the investment accounts you connected via Plaid AND added manually to determine the sum of your investments. “Investments change” is the percent change in the sum of your investment accounts since the last time you logged in. $APP_NAME calculates this by comparing the sum of your investments from your last login to your current login and outputs the difference as a percentage.',
        netWorth: 'Change in net worth',
        networthAction: 'Visit our Returning user dialog article to learn more.',
        networthTooltip:
            '$APP_NAME calculates your net worth by subtracting your debts from your assets. “Change in net worth” is the percent change in your net worth since the last time you logged in. $APP_NAME calculates this percentage by comparing the net worth from your last login to the net worth from your current login and outputting the difference as a percentage.',
        savings: 'Savings change',
        savingsAction: 'Visit our Returning user dialog article to learn more.',
        savingsTooltip:
            '$APP_NAME uses the checking and savings accounts you connected via Plaid, AND other depository accounts you added manually, to determine your savings. “Savings change” is the percent change in the sum of the balances of depository accounts since the last time you logged in. $APP_NAME calculates this by comparing the sum of your depository account balances from your last login to your current login and outputs the difference as a percentage.',
        transactions: 'New transactions'
    },
    StatusCode: {
        OffTrack: 'Off track',
        'OffTrack-action': 'Get back on track!',
        OnTrack: 'On track',
        'OnTrack-action': 'Stay on track.'
    },
    StatusDrawer: {
        netWorthLink: 'Read more about net worth',
        netWorthTooltip:
            'Your current net worth is the sum of your current total asset value minus your current total debt value based on the accounts you have added to $APP_NAME',
        netWorthTooltipTitle: 'Current net worth',
        planLink: 'Learn more about your plan',
        planStatusLink: 'Learn more about status',
        planTooltip:
            'Your plan status is a comprehensive assessment of your financial landscape and the feasibility of your financial plan.',
        planTooltipTitle: 'Your plan status'
    },
    SwitchButton: ' switch button',
    TakeVacationDrawer: {
        body: 'See how the cost of a vacation will affect your plan. Don’t have the money yet? Add an optional savings goal.',
        startDate: 'When do you plan on going on vacation?'
    },
    TargetMonthlySpending: {
        modalBody: 'Track your total monthly spending across all available accounts.',
        modalHeader: 'Set Target Monthly Spending',
        title: 'Target amount',
        viewTransactions: 'View transactions'
    },
    TargetMonthlySpendingCallout: {
        body: 'A monthly target is a custom amount you can set and track your spending against.',
        button: 'Set Target',
        header: 'Set a target for your monthly spending'
    },
    TertiaryNavigation: {
        history: 'History',
        tertiaryNav: 'Tertiary Navigation'
    },
    Timeline: {
        debtsLegendBody:
            "Here is your projected debt after life events, without inflation. PlanAhead shows everything in today's dollars so it is easier to understand.",
        debtsLegendTitle: 'Debt projections',
        eventDisplaySize: 'Event display size',
        expenseLegendBody: `Here are your annual expenses of <a href="$\{args[1]}">$\{args[0]}</a> projected over time after Life Events, without inflation. PlanAhead shows everything in today's dollars, so it is easier to understand.`,
        expenseLegendTitle: 'Expense projections',
        incomeLegendBody: `Here, is your annual income of <a href="$\{args[1]}">$\{args[0]}</a>, grown at <a href="$\{args[3]}">$\{args[2]}</a> per year after Life Events, without inflation. PlanAhead shows everything in today's dollars, so it is easier to understand.`,
        incomeLegendTitle: 'Income projections',
        investmentsLegendBody:
            "Here are your projected assets after life events, without inflation. PlanAhead shows everything in today's dollars so it is easier to understand.",
        investmentsLegendTitle: 'Asset Projections',
        learnMore: 'Learn more about projections',
        netWorthLegendBody:
            "Here is your projected Net Worth after life events, without inflation. PlanAhead shows everything in today's dollars so it is easier to understand.",
        netWorthLegendTitle: 'Net worth projections',
        noBars: 'Complete Step 1 to start your plan.'
    },
    TimelineDrawer: {
        dangerLevel1: 'You are spending into your savings',
        dangerLevel2: 'You are out of money',
        thisYear: '(This year)',
        title: 'Your timeline'
    },
    Tooltips: {
        moreInfo: 'more info',
        yourAverageMonthlySpending: {
            body: 'Based on the last 12 full months from the accounts you’ve included in SpendSmart™.'
        }
    },
    TotalAverageInfoModal: {
        anchorTitle1: 'Learn about your spending total and graph',
        anchorTitle2: 'How are totals and averages calculated?',
        averageBody:
            'Averages are calculated based on your expense transactions for up to the last 12 full months.' +
            ' Large, infrequent purchases can skew your averages. Set the frequency of these kinds of transactions to “one-time” or “ignore” to exclude them from your average calculations.',
        averageHeader: 'Averages',
        title: 'Total Average Modal',
        totalBody:
            'Your totals — including the graph, category spending totals, and “total spent” — show the sum' +
            ' of your expense transactions from your connected accounts. Totals do not include transactions with' +
            ' frequencies you’ve set to “ignore” and transactions with types marked as “transfer” or “income.”',
        totalHeader: 'Totals'
    },
    TransactionClassificationDashboardModal: {
        alt: "See what's new in SpendSmart",
        listItems: {
            item1: {
                body: `<p>You now have three types of transactions: expenses, income, and <b>transfers</b>. SpendSmart™
                automatically assigns a type to each of your transactions. You can change a transaction's
                type by recategorizing it.</p>`,
                mobileBody: `<p>You now have three types of transactions: expenses, income, and transfers. SpendSmart™
                automatically assigns a type to each of your transactions. You can change a transaction's
                type by recategorizing it.</p>`,
                title: 'Introducing Transfers'
            },
            item2: {
                body: `<p>Transactions marked as <b>transfers</b> are now automatically excluded from your spending totals
                and averages.</p>`,
                mobileBody: `<p>Transactions marked as transfers are now automatically excluded from your spending totals
                and averages.</p>`,
                title: 'Improved spending totals and averages'
            },
            item3: {
                body: `<p>The new categorization will automatically apply to all new transactions. Existing
                transactions, budgets, and rules will also have the new categories and subcategories if
                applicable.</p>`,
                mobileBody: `<p>The new categorization will automatically apply to all new transactions. Existing
                transactions, budgets, and rules will also have the new categories and subcategories if
                applicable.</p>`,
                title: 'New categories and subcategories'
            }
        },
        skipTheTour: 'Skip the Tour',
        takeTheTour: 'Take the Tour',
        title: "See what's new in SpendSmart™"
    },
    TransactionClassificationWalkmePopups: {
        item1: {
            closeButtonAriaLabel: 'Close Step 1/5',
            content:
                'Totals like this one may look different with improved categorization between expenses, income, and transfers.',
            mobileContent:
                'Totals like this one may look different with improved categorization between expenses, income, and transfers.',
            nextButtonAriaLabel: 'Next Step 2/5',
            nextButtonText: 'Next',
            progressText: '1/5'
        },
        item2: {
            closeButtonAriaLabel: 'Close Step 2/5',
            content:
                'New categories and subcategories will appear here. Your category totals, averages, and budgets may look different as well.',
            mobileContent:
                'New categories and subcategories will appear here. Your category totals, averages, and budgets may look different as well.',
            nextButtonAriaLabel: 'Next Step 3/5: Transactions',
            nextButtonText: 'Next: Transactions',
            progressText: '2/5'
        },
        item3: {
            closeButtonAriaLabel: 'Close Step 3/5',
            content: 'The new "Transfer" type will appear here.',
            mobileContent:
                'View a transaction\'s details to see the new "Transfer" type applied to relevant transactions.',
            nextButtonAriaLabel: 'Next Step 4/5',
            nextButtonText: 'Next',
            progressText: '3/5'
        },
        item4: {
            closeButtonAriaLabel: 'Close Step 4/5',
            content:
                "Use the new category list to recategorize a transaction. Recategorizing may also change a transaction's type.",
            mobileContent:
                "Edit a transaction's details to recategorize using the new category list. Recategorizing may also change a transaction's type.",
            nextButtonAriaLabel: 'Next Step 5/5: Transaction Rules',
            nextButtonText: 'Next: Transaction Rules',
            progressText: '4/5'
        },
        item5: {
            closeButtonAriaLabel: 'Close Step 5/5',
            content: 'Create rules for all of your transactions in one place.',
            mobileContent: 'Create rules for all of your transactions in one place.',
            nextButtonAriaLabel: 'Back to Dashboard',
            nextButtonText: 'Back to Dashboard',
            progressText: '5/5'
        }
    },
    TransactionDetails: {
        account: 'Account',
        amount: 'Amount',
        back: 'Back',
        category: 'Category',
        editName: 'Edit Transaction Name',
        frequency: 'Frequency',
        incomeSource: 'Income Source',
        merchantName: 'Merchant Name',
        subtitle:
            'Update the name, category, or frequency of a single transaction. Create a rule to apply a certain category to existing and future auto-categorized transactions.',
        textToMatch: 'text to match',
        title: 'Transaction Details',
        transactionName: 'Transaction Name',
        type: 'Type'
    },
    TransactionTable: {
        rules: `You can create and add rules to define how transactions get categorized by $\{args[0]}.`
    },
    TransactionsTable: {
        approve: 'Approve',
        approveCategoryError: `Please select a category to approve <b>$\{args[0]}</b>`,
        bulkEdit: {
            addRule1: 'Create a rule to change all ',
            addRule2: ' transactions?',
            addRule3: ', and all other selected transactions?',
            bulkSelected: `$\{args[0]} Transaction$\{args[0] === 1 ? '' : 's'} selected`,
            category: 'Category',
            changeCategory: 'Change Category',
            'changeCategory?': 'Change category?',
            changeFrequency: 'Change Frequency',
            'changeFrequency?': 'Change frequency?',
            changeSource: 'Change Source',
            'changeSource?': 'Change source?',
            closeBulkEdit: 'Close bulk edit transactions banner',
            customSubcategory: 'Add custom subcategory',
            ruleInfo: 'By selecting “Apply” you will replace any previous rules you created for these transactions.',
            source: 'Source'
        },
        category: {
            categorySelector: 'Select Category',
            label: 'Category'
        },
        edit: 'Edit',
        emptyState: {
            clearFilters: 'Clear filters',
            clearSearch: 'Clear search',
            noTransactions: 'No transactions match this criteria.',
            noTransactionsMatchSearch: 'No transactions found with that search term.',
            youHaveNoTransactionsToReview: 'You have no transactions to review.',
            youreUpToDate: 'You’re up to date'
        },
        frequency: {
            frequencySelector: 'Select Frequency',
            ignore: 'Ignore transaction',
            label: 'Frequency',
            oneTime: 'One-time transaction',
            typical: 'Typical transaction'
        },
        heading: {
            amount: 'AMOUNT',
            approve: 'APPROVE',
            category: 'CATEGORY',
            date: 'DATE',
            edit: 'EDIT',
            frequency: {
                budget: {
                    body: '<b>Typical</b> transactions are expected and included in averages and spending totals. <br><b>One-time</b> transactions are included in spending totals, but are not included in averages. <br><b>Ignored</b> transactions are left out of averages and spending totals completely.'
                },
                fullPlan: {
                    body: '<b>Typical</b> transactions are expected, occur regularly, and included in projections.<br><b>One-time</b> transactions occur on one occasion and are not included in projections.<br><b>Ignored</b> transactions are left out of your plan completely.',
                    linkName: 'Learn more about projections'
                },
                title: 'FREQUENCY',
                tooltipTitle: 'Transaction Frequencies'
            },
            name: 'NAME',
            selectAll: 'Select All',
            type: 'TYPE'
        },
        income: {
            addIncomeSource: 'Add Income Source',
            incomeSelector: 'Select Income',
            label: 'Source'
        },
        type: {
            expense: 'Expense',
            income: 'Income',
            transfer: 'Transfer'
        }
    },
    TransactionsTableHeaderCheckbox: {
        name: 'Transactions Table Header Checkbox',
        selectAll: 'Select all'
    },
    TransactionsView: {
        cashFlowOverview: 'Cash flow',
        dateRange: 'Choose date range',
        expensesOverview: 'Expenses',
        filters: {
            account: {
                title: 'Account'
            },
            category: {
                title: 'Category'
            },
            date: {
                currentMonth: 'Current Month',
                custom: 'Custom',
                lastMonth: 'Last Month',
                lastTwelveMonths: 'Last 12 Months',
                lastWeek: 'Last 7 Days',
                lastYear: 'Last Year',
                title: 'Date',
                yesterday: 'Yesterday'
            },
            income: {
                longTitle: 'Income Source',
                newIncomeSource: 'New Income Source',
                title: 'Income'
            },
            parent: {
                filterBy: 'Filter by:'
            },
            type: {
                expense: 'Expense',
                income: 'Income',
                title: 'Type'
            }
        },
        hiddenLabel: 'Show ignored',
        incomeOverview: 'Income',
        manageRules: 'Manage Rules',
        noOfTransactions: `$\{args[0]} transaction$\{args[0] === 1 ? '' : 's'}`,
        review: {
            approve: 'Approve',
            banner: {
                linkDescription: 'See transactions to review',
                transactionsNeedReview: `You have $\{args[0]} transaction$\{args[0] === 1 ? '' : 's'} to review. `
            },
            closeBulkEdit: 'Close bulk approve review transactions banner',
            reviewTransactions: 'Review Transactions',
            transactionsNeedReview: `$\{args[0]} transaction$\{args[0] === 1 ? '' : 's'} need$\{args[0] === 1 ? 's' : ''} review`,
            transactionsSelected: `$\{args[0]} transaction$\{args[0] === 1 ? '' : 's'} selected`,
            transactionsThatAreSpendingOutliers: 'Transactions that need categorization require your review.'
        },
        searchPlaceholder: 'Search Transactions',
        searchPlaceholderShort: 'Search',
        subtitle:
            'View and edit your transaction details. Update your categories and frequencies. Create rules to apply changes to auto-categorized transactions.',
        title: 'Transactions',
        transferInOverview: 'Transfers In',
        transferOutOverview: 'Transfers Out'
    },
    UnifiedReviewTransactionsDrawer: {
        subtitle:
            'Transactions that are spending outliers, need categorization, or changes in frequency. Reviewing transactions makes your projections more precise.',
        title: `$\{args[0]} transactions need review`
    },
    UnifiedRulesDrawer: {
        subtitle: 'Edit or delete your transaction rules. Rules are applied from top to bottom.',
        title: 'Transactions rules'
    },
    UnifiedTransactionsDrawer: {
        title: `$\{args[0]} Transactions`
    },
    UnifiedTransactionsTable: {
        addRule1: 'Create a rule to change all ',
        addRule2: ' transactions?',
        bulkEditError: 'You can’t recategorize income and expenses together.',
        bulkSelected: 'Transactions selected',
        category: 'Category',
        changeCategory: 'Change Category',
        'changeCategory?': 'Change category?',
        changeFrequency: 'Change Frequency',
        'changeFrequency?': 'Change frequency?',
        customSubcategory: 'Add custom subcategory'
    },
    WelcomeSlider: {
        alt1: 'Example bar graph showing spend over time',
        alt2: 'American Express logo and bank icon',
        alt3: 'Example of transaction categories, like food and dining',
        alt4: 'Example of a category budget in progress',
        body1: `<p>Get deeper insights into your overall spending.</p>
            <p>Spot patterns and trends with detailed visualizations.</p>
            <p>Customize how you’d like to track your spending.</p>
            <br>
            <p>Learn how with this quick overview.</p>`,
        body2: `<p>Automatically see your spending across your American Express consumer credit card and checking accounts.</p>
                <p>Link your spending accounts from other institutions to get an even better view.</p>`,
        body3: `<p>View your auto-categorized transactions and customize how your spending is shown in SpendSmart. Create rules to automatically apply your customizations.</p>`,
        body4: `<p>You can set a target for your overall monthly spending.</p><p>You can also set a budget for spending in
            specific categories. You can do either one, both, or neither.</p><p>Whatever works best for you.</p>`,
        close: 'Close welcome slider',
        getStarted: 'Get Started',
        mobileBody1: `<p>Get deeper insights into your overall spending. Spot patterns and trends with detailed visualizations. Customize how you’d like to track your spending.</p>
                        <br>
                        <p>Learn how with this quick overview.</p>`,
        mobileBody2: `<p>Automatically see your spending across your American Express consumer credit card and checking accounts. Link your spending accounts from other institutions to get an even better view.</p>`,
        mobileBody3: `<p>View your auto-categorized transactions and customize how your spending is shown in SpendSmart.</p><p>Create rules to automatically apply your customizations.</p>`,
        mobileBody4: `<p>You can set a target for your overall monthly spending. You can also set a budget for spending in specific categories. You can do either one, both, or neither. Whatever works best for you.</p>`,
        next: 'Next',
        title1: 'Welcome to SpendSmart™',
        title2: 'Get to know your spending habits',
        title3: 'Customize your transactions',
        title4: 'Choose how you’d like to track your spending'
    },
    WindfallDrawer: {
        afterTax: 'Add the expected after-tax amount for a more accurate projection.',
        inheritance: {
            howMuch: 'Inheritance amount'
        },
        windfall: {
            howMuch: 'Windfall amount'
        }
    },
    WrongNumbersCallout: {
        body: 'Large, infrequent purchases, transfers, and transactions in the wrong categories can skew your spending totals and averages. View your transactions to confirm that your categories and frequencies are labeled correctly. ',
        button: 'View Transactions',
        header: 'Do any of these numbers look wrong?'
    },
    addAccountDrawer: {
        addButton: `Add $\{args[0]}`,
        addCryptoButton: {
            heading: 'Add crypto',
            subheading: 'Add crypto currencies and get automated price updates.'
        },
        addDebtButton: {
            heading: 'Add debt or loans manually',
            subheading: 'Add mortgages, loans, and other liability values. Update balances by hand.'
        },
        addInvestmentButton: {
            heading: 'Add banks, investments, and assets manually',
            subheading: 'Add your bank, investements, and property values. Update balances by hand.'
        },
        addNonAmericanExpressAccounts: 'Add non-American Express Accounts',
        cashAndBanking: {
            buttonSubtitle: 'Add your cash and checking and savings accounts. Update your balances manually.',
            buttonTitle: 'Add Cash & Banking'
        },
        connectAccounts:
            'Connect accounts to automatically sync balances and transactions. Not ready to sync? Add balances, property, debt and more manually.',
        gainMoreControl: 'Gain more control over your projections',
        investmentsAndRetirement: {
            buttonSubtitle: 'Add your stocks, bonds, pension, 401K, and IRA. Update your balances manually.',
            buttonTitle: 'Add Investments & Retirement'
        },
        loansAndDebt: {
            buttonSubtitle: 'Add your student, personal, home, and auto loans. Update your balances manually.',
            buttonTitle: 'Add Loans & Debt'
        },
        makeYourPlanMoreAccurate: 'Make your plan more accurate with your complete financial profile',
        propertyAndAssets: {
            buttonSubtitle: 'Add your home, vehicles, collectibles, and property. Update your balances manually.',
            buttonTitle: 'Add Property & Assets'
        },
        readMoreAboutConnectingAccounts: 'Read more about connecting accounts',
        seeIfYoureOverspending: 'See if you’re overspending in real time',
        subtitle: 'Connect your online accounts',
        syncAccountButton: {
            disabledSubheading: 'Syncing new accounts is currently disabled.',
            heading: 'Sync a financial account',
            subheading: 'Enter your bank credentials to add your accounts to PlanAhead'
        },
        syncError: 'We got an error trying to add that institution',
        termsAndConditions: [
            'See the ',
            'Terms & Conditions',
            ' for more information about how we integrate with Plaid, a financial services company, to connect your financial institutions.'
        ],
        title: 'Add an Account',
        updateButton: `Update $\{args[0]}`,
        whyConnect1: 'Make your plan more accurate with your complete financial profile',
        whyConnect2: 'Gain more control over your projections',
        whyConnect3: 'Your balances stay up-to-date automatically',
        whyConnect4: 'See if you’re overspending in real time',
        whyConnectHeading: 'Why should you connect?',
        whyConnectLinkText: 'Read more about connecting accounts',
        whyConnectLinkUrl: 'https://www.americanexpress.com',
        whyShouldUouConnect: ' Why should you connect?',
        yourBalancesStay: 'Your balances stay up-to-date automatically'
    },
    plaidButton: {
        connectAccounts: 'Connect Accounts',
        disabled: 'Syncing new accounts is currently disabled',
        reconnect: 'Reconnect'
    }
};
